/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { AutoComplete, Image, Input, Layout, Menu, Row, Space, Spin, Tooltip, Typography } from 'antd';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { LuPackageCheck } from 'react-icons/lu';
import {
  AiOutlineBook,
  AiOutlineCar,
  AiOutlineCompass,
  AiOutlineDeliveredProcedure,
  AiOutlineDeploymentUnit,
  AiOutlineDollar,
  AiOutlineException,
  AiOutlineFile,
  AiOutlineFilePdf,
  AiOutlineFileSearch,
  AiOutlineFileText,
  AiOutlineGlobal,
  AiOutlineHistory,
  AiOutlineInbox,
  AiOutlineSolution,
  AiOutlineUser,
  AiOutlineUserAdd,
} from 'react-icons/ai';
import {
  MdDashboardCustomize,
  MdDriveFolderUpload,
  MdFreeCancellation,
  MdOutlineFreeCancellation,
  MdSupervisorAccount,
} from 'react-icons/md';
import { TbPackageExport } from "react-icons/tb";
import { GiCardExchange } from "react-icons/gi";
import { LiaAdversal } from 'react-icons/lia';
import { FaFileInvoiceDollar, FaMapMarkedAlt, FaTruckMoving } from 'react-icons/fa';
import { IoMdBarcode } from 'react-icons/io';
import { BiPulse, BiRefresh, BiSearch, BiTrip, BiX } from 'react-icons/bi';
import { BsBox, BsClockHistory, BsReceiptCutoff, BsTruck } from 'react-icons/bs';
import { CiStickyNote } from 'react-icons/ci';
import { FaCity, FaPallet, FaShippingFast, FaTruckLoading } from 'react-icons/fa';
import { FcApproval } from 'react-icons/fc';
import { GrDocumentConfig } from 'react-icons/gr';
import { HiOutlineCash, HiOutlineDocumentReport } from 'react-icons/hi';
import { FaTruckFast } from 'react-icons/fa6';
import { MdOutlineBusAlert, MdOutlineDeviceThermostat, MdProductionQuantityLimits } from 'react-icons/md';
import { SiFlathub } from 'react-icons/si';
import { TbBrandBooking, TbFileInvoice, TbMessageCircleQuestion, TbLayoutDashboard } from 'react-icons/tb';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { GiOilDrum } from 'react-icons/gi';
import { IoSpeedometerOutline } from 'react-icons/io5';
import { TiRefreshOutline } from 'react-icons/ti';
import { useIdleTimer } from 'react-idle-timer';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import imageUrl from '../../assets/images/ajex_logo.png';
import { useUserContextHook } from '../../hooks/useUserContextHook';
import { SessionStorage } from '../../services/storage';
import { useLoginStore } from '../../stores/LoginStore';
import {
  CountryEnum,
  Employee,
  MENU_APP_MAP,
  PRICING_TEAM_USERS,
  PodDownloadAccess,
  TRIP_PLAN_MENU,
  UserEnum,
  applicationTimer,
  getRandom,
  isAccessible,
  isEditOdometerTeam,
  isEditVehicleTeam,
  isEmpLuqman,
  isFuelReportTeam,
  isIdleVehicleExceptionTeam,
  isMarkenTeam,
  isMateenProdUser,
  isNewAccessible,
  isPricingTeam,
  isProdMode,
} from '../../utils/app-common';
import { millisecondsToMinute } from '../../utils/luxon';
import FooterComponent from './FooterComponent';
import SignOutComponent from './SignOutComponent';
import { TbSquareLetterM } from 'react-icons/tb';
import { RiFolderHistoryFill, RiFolderTransferFill, RiTruckFill } from 'react-icons/ri';
import { AdhocTripTabRoles, AdhocVendor_TripApproval_Roles, DEMURRAGE_OCC_APPROVAL_ACCESS, FTE_CONFIGURATION_ACCESS, GeoFencingAccess, PRICING_TEAM_ACCESS } from '../../utils/access-list';
import NotificationDrawer from '../NotificationList/NotificationDrawer';

const { Header, Content, Sider } = Layout;

const ImageDiv = styled.div<{ collapsed?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 12px;
  height: 60px;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  overflow: hidden;
  transition: padding 0.2s;
`;

const RefreshComponent = () => {
  const GetMasterDetailAction = useLoginStore(
    (state) => state?.GetMasterDetailAction
  );
  const { promiseInProgress: masterProgress } = usePromiseTracker({
    area: 'get-master-area',
  });

  const onGetMaster = () => {
    trackPromise(GetMasterDetailAction(), 'get-master-area');
  };
  return (
    <Row>
      <Spin spinning={masterProgress} size='default' tip='Loading Master'>
        <BiRefresh onClick={onGetMaster} size={18} title='Get Masters' />
      </Spin>
    </Row>
  );
};

interface FlatMenuItem {
  label: string;
  path: string;
  name: string;
}

const MENU_LABEL_SEPARATOR = ' > ';

// Walks the menu tree (any depth) and returns every visible, navigable leaf with its breadcrumb label.
const flattenMenuItems = (items: any[], parentLabels: string[] = []): FlatMenuItem[] => {
  const result: FlatMenuItem[] = [];
  for (const item of items) {
    if (item.hidden) continue;
    const labels = [...parentLabels, item.name];
    if (item.children?.length) {
      result.push(...flattenMenuItems(item.children, labels));
    } else if (item.pathname && !item.disabled) {
      result.push({
        label: labels.join(MENU_LABEL_SEPARATOR),
        path: item.pathname,
        name: item.name,
      });
    }
  }
  return result;
};

interface NavMenuItemConfig {
  label: string;
  key: string | number;
  path: string;
  icon?: JSX.Element;
  hidden?: boolean;
}

const toNavMenuItem = (item: NavMenuItemConfig) => ({
  pathname: item.path,
  name: item.label,
  key: item.key,
  label: item.path ? (
    <NavLink to={item.path} key={item.key} replace>
      {item.label}
    </NavLink>
  ) : (
    item.label
  ),
  icon: item.icon,
  hidden: item.hidden,
});

// Nested sub-menu group. The group is hidden only when every child is hidden,
// so access is still decided per item.
const buildMenuGroup = (label: string, icon: JSX.Element, children: NavMenuItemConfig[]) => {
  const menuChildren = children.map(toNavMenuItem);
  return {
    pathname: '',
    name: label,
    key: `menu-group-${label}`,
    label,
    icon,
    hidden: menuChildren.every((child) => child.hidden),
    children: menuChildren,
  };
};
const TimerComponent = () => {
  const { clearDetailHandle } = useUserContextHook();
  const [remaining, setRemaining] = useState(applicationTimer);

  const navigate = useNavigate();
  const location = useLocation();
  const onIdle = () => {
    clearDetailHandle?.();
    navigate('/', { state: { from: location } });
  };
  const { getRemainingTime } = useIdleTimer({
    onIdle,
    timeout: applicationTimer,
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime()));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, [getRemainingTime]);
  return <Typography.Text ellipsis>{millisecondsToMinute(remaining)}</Typography.Text>;
};
const HeaderComponent = ({ menuItems }: { menuItems: any[] }) => {
  const { employeeDetail } = useUserContextHook();
  const navigate = useNavigate();
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const inputRef = useRef<any>(null);

  const flatItems = useMemo(() => flattenMenuItems(menuItems), [menuItems]);

  const options = useMemo(() => {
    const q = searchValue.trim().toLowerCase();
    if (!q) return [];
    return flatItems
      .filter((item) => item.label.toLowerCase().includes(q))
      .slice(0, 12)
      .map((item) => {
        const parts = item.label.split(MENU_LABEL_SEPARATOR);
        const leaf = parts.pop();
        return {
          // Breadcrumb label is unique; the path is not (the same page can sit under more than one menu).
          value: item.label,
          label: (
            <span style={{ fontSize: 13 }}>
              {parts.map((part) => (
                <span key={part}>
                  <span style={{ color: '#888' }}>{part}</span>
                  <span style={{ color: '#aaa', margin: '0 4px' }}>›</span>
                </span>
              ))}
              <span style={{ color: '#1a1a2e', fontWeight: 500 }}>{leaf}</span>
            </span>
          ),
        };
      });
  }, [searchValue, flatItems]);

  const openSearch = () => {
    setSearchOpen(true);
    setTimeout(() => inputRef.current?.focus(), 50);
  };

  const closeSearch = () => {
    setSearchOpen(false);
    setSearchValue('');
  };

  const handleSelect = (label: string) => {
    const item = flatItems.find((i) => i.label === label);
    if (!item) return;
    if (MENU_APP_MAP[item.name]) {
      SessionStorage.set('token', SessionStorage.get('token')!);
      window.open(`${window.location.origin}${MENU_APP_MAP[item.name]}`, '_blank');
    } else {
      navigate(item.path);
    }
    closeSearch();
  };

  useEffect(() => {
    if (!searchOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeSearch();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [searchOpen]);

  return (
    <Header
      className='header'
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        width: '100%',
        height: '60px',
        padding: '0 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: '#ffffff',
        borderBottom: '1px solid #f0f0f0',
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
      }}
    >
      <Typography.Title level={4} style={{ margin: 0, color: '#1a1a2e', letterSpacing: 1 }}>
        AIMS
      </Typography.Title>

      <Space align='center' size={16}>
        <RefreshComponent />
        {isMateenProdUser() && (
          <Tooltip title='Service Diagnostics'>
            <span
              onClick={() => navigate('/diagnostics')}
              style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', padding: '4px 6px', borderRadius: 6, color: '#555' }}
            >
              <BiPulse size={20} />
            </span>
          </Tooltip>
        )}
        {/* <TimerComponent /> */}
        {searchOpen ? (
          <AutoComplete
            value={searchValue}
            options={options}
            onChange={setSearchValue}
            onSelect={handleSelect}
            style={{ width: 400 }}
            notFoundContent={searchValue.trim() ? <span style={{ fontSize: 13 }}>No menu items found</span> : null}
          >
            <Input
              ref={inputRef}
              autoFocus
              prefix={<BiSearch size={14} color='#888' />}
              suffix={
                <BiX
                  size={16}
                  color='#aaa'
                  style={{ cursor: 'pointer' }}
                  onClick={closeSearch}
                />
              }
              placeholder='Search menu...'
              style={{ borderRadius: 6 }}
            />
          </AutoComplete>
        ) : (
          <Tooltip title='Search menu (⌘K)'>
            <span
              onClick={openSearch}
              style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', padding: '4px 6px', borderRadius: 6, color: '#555' }}
            >
              <BiSearch size={20} />
            </span>
          </Tooltip>
        )}

        <Typography.Text style={{ fontSize: 13, color: '#555' }}>
          <span style={{ color: '#cf1322', fontWeight: 600 }}>Welcome, </span>
          <span style={{ fontWeight: 500, color: '#1a1a2e' }}>
            {employeeDetail?.name ?? ''}
          </span>
          {employeeDetail?.position && (
            <span style={{ color: '#888', marginLeft: 4 }}>
              — {employeeDetail.position}
            </span>
          )}
        </Typography.Text>
        <NotificationDrawer />
        <SignOutComponent />
      </Space>
    </Header>
  );
};
const addTooltips = (menuItems: any[]): any[] =>
  menuItems.map((item) => {
    const text = item.name;
    const needsTooltip = typeof text === 'string' && text.length > 19;
    return {
      ...item,
      label: needsTooltip ? (
        <Tooltip title={text} placement='right'>
          <span>{item.label}</span>
        </Tooltip>
      ) : item.label,
      children: item.children ? addTooltips(item.children) : undefined,
    };
  });

const AppLayout = () => {
  const isCollapsed = SessionStorage.get('isCollapsed') ?? true;

  const [collapsed, setCollapsed] = useState(Boolean(isCollapsed));
  const location = useLocation();
  const { employeeDetail } = useUserContextHook();
  // TODO: Need to refactor the code.
  const items = useMemo(() => {
    return [
      {
        label: 'Dashboard',
        key: getRandom(),
        icon: <MdDashboardCustomize size={17} />,
        children: [
          {
            label: 'Shipment Summary',
            key: getRandom(),
            path: '/shipment-summary',
            icon: <TbLayoutDashboard size={17} />,
            hidden: !(
              isAccessible([
                UserEnum.MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.CUSTOMER_SERVICE,
                UserEnum.MANIFESTER,
                UserEnum.ADMIN,
                UserEnum.SALES_PERSON,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.FINANCE,
                UserEnum.DATA_ANALYST,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATOR_CASH_COLLECTOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.CSV,
                UserEnum.OPS_MANAGER,
                UserEnum.FINANCE_CONTROLLER,
                UserEnum.DATA_LOGGER,
                UserEnum.QUOTATION,
                UserEnum.CUSTOMER_CARE,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.OPS_CASH,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.GATEWAY_USER,
              ]) ||
              isAccessible(
                [Employee.BANDER_ALLAFI, Employee.NOHA_KARKADAN],
                [CountryEnum.BAHRAIN, CountryEnum.KSA, CountryEnum.UAE],
                true,
              )
            ),
          },
          {
            label: 'Pickup & Delivery Heatmap',
            key: getRandom(),
            path: 'pickup-delivery-heatmap',
            icon: <MdSupervisorAccount size={17} />,
            hidden: !(
              isAccessible([
                UserEnum.MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.CUSTOMER_SERVICE,
                UserEnum.MANIFESTER,
                UserEnum.ADMIN,
                UserEnum.SALES_PERSON,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.FINANCE,
                UserEnum.DATA_ANALYST,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATOR_CASH_COLLECTOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.CSV,
                UserEnum.OPS_MANAGER,
                UserEnum.FINANCE_CONTROLLER,
                UserEnum.DATA_LOGGER,
                UserEnum.QUOTATION,
                UserEnum.CUSTOMER_CARE,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.OPS_CASH,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.GATEWAY_USER,
              ]) ||
              isAccessible(
                [Employee.BANDER_ALLAFI, Employee.NOHA_KARKADAN],
                [CountryEnum.BAHRAIN, CountryEnum.KSA, CountryEnum.UAE],
                true,
              )
            ),
          },
          {
            label: 'Supervisor Dashboard',
            key: getRandom(),
            path: 'dashboard/supervisor-dashboard',
            icon: <MdSupervisorAccount size={17} />,
            hidden: !(
              isAccessible([
                UserEnum.MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.CUSTOMER_SERVICE,
                UserEnum.MANIFESTER,
                UserEnum.ADMIN,
                UserEnum.SALES_PERSON,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.FINANCE,
                UserEnum.DATA_ANALYST,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATOR_CASH_COLLECTOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.CSV,
                UserEnum.OPS_MANAGER,
                UserEnum.FINANCE_CONTROLLER,
                UserEnum.DATA_LOGGER,
                UserEnum.QUOTATION,
                UserEnum.CUSTOMER_CARE,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.OPS_CASH,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.GATEWAY_USER,
              ]) ||
              isAccessible(
                [Employee.BANDER_ALLAFI, Employee.NOHA_KARKADAN],
                [CountryEnum.BAHRAIN, CountryEnum.KSA, CountryEnum.UAE],
                true,
              )
            ),
          },
          {
            label: 'FTE Configuration',
            key: getRandom(),
            path: 'fte-configuration',
            icon: <MdSupervisorAccount size={17} />,
            hidden: !isNewAccessible({
              employeeIds: FTE_CONFIGURATION_ACCESS,
            }),
          },
        ].map((item) => ({
          pathname: item?.path,
          name: item?.label,
          key: item?.key,
          label: item?.path ? (
            <NavLink to={item?.path} key={item?.key} replace>
              {item?.label}
            </NavLink>
          ) : (
            item?.label
          ),
          icon: item?.icon,
          hidden: item?.hidden,
        })),
        hidden: !(
          isAccessible([
            UserEnum.MANAGER,
            UserEnum.OPERATION_SUPERVISOR,
            UserEnum.CUSTOMER_SERVICE,
            UserEnum.MANIFESTER,
            UserEnum.ADMIN,
            UserEnum.SALES_PERSON,
            UserEnum.SALES_MANAGER,
            UserEnum.SALES_DIRECTOR,
            UserEnum.FINANCE,
            UserEnum.DATA_ANALYST,
            UserEnum.FLEET_SUPERVISOR,
            UserEnum.OPERATION_CS_SUPERVISOR,
            UserEnum.OPERATION_STAFF,
            UserEnum.OPERATOR_CASH_COLLECTOR,
            UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
            UserEnum.CSV,
            UserEnum.OPS_MANAGER,
            UserEnum.FINANCE_CONTROLLER,
            UserEnum.DATA_LOGGER,
            UserEnum.QUOTATION,
            UserEnum.CUSTOMER_CARE,
            UserEnum.OCC_SOLUTION,
            UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
            UserEnum.OPS_CASH,
            UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
            UserEnum.GATEWAY_USER,
          ]) ||
          isAccessible(
            [Employee.BANDER_ALLAFI, Employee.NOHA_KARKADAN],
            [CountryEnum.BAHRAIN, CountryEnum.KSA, CountryEnum.UAE],
            true,
          )
        ),
      },

      {
        label: 'A-One',
        key: getRandom(),
        path: '/a-one',
        icon: <TbPackageExport size={17} />,
        children: [
          {
            label: 'Waybills',
            key: getRandom(),
            path: '/a-one/a-one-waybills',
            icon: <GiCardExchange size={17} />,
            hidden: !(
              isAccessible([
                UserEnum.ADMIN,
                UserEnum.MANAGER,
                UserEnum.A_ONE,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.CSV,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,

              ])
            ),
          },
          {
            label: 'Handover',
            key: getRandom(),
            path: '/a-one/handover',
            icon: <GiCardExchange size={17} />,
            hidden: !(
              isAccessible([
                UserEnum.ADMIN,
                UserEnum.MANAGER,
                UserEnum.A_ONE,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.CSV,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,

              ])
            ),
          },
          {
            label: 'POD Upload',
            key: getRandom(),
            path: '/a-one/pod-upload',
            icon: <MdDriveFolderUpload size={17} />,
            hidden: !(
              isAccessible([
                UserEnum.MANAGER,
                UserEnum.A_ONE,
              ])
            ),
          },
          {
            label: 'POD Dispatch',
            key: getRandom(),
            path: '/a-one/pod-dispatch',
            icon: <RiFolderTransferFill size={17} />,
            hidden: !(
              isAccessible([
                UserEnum.MANAGER,
                UserEnum.A_ONE,
              ])
            ),
          },

        ].map((item) => ({
          pathname: item?.path,
          name: item?.label,
          key: item?.key,
          label: item?.path ? (
            <NavLink to={item?.path} key={item?.key} replace>
              {item?.label}
            </NavLink>
          ) : (
            item?.label
          ),
          icon: item?.icon,
          hidden: item?.hidden,
        })),
        hidden: !isAccessible(
          [UserEnum.ADMIN,
          UserEnum.MANAGER,
          UserEnum.A_ONE,
          UserEnum.OPERATION_CS_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
          UserEnum.CSV,
          UserEnum.OPS_MANAGER,
          UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
          UserEnum.OPERATION_SUPERVISOR,
          UserEnum.OPERATION_STAFF,
          UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
          ],
          [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
        ),
      },
      // {
      //   label: "Shipment Summary",
      //   key: getRandom(),
      //   path: "/shipment-summary",
      //   icon: <TbLayoutDashboard size={17} />,
      //   hidden: !(isAccessible(
      //     [
      //       UserEnum.MANAGER,
      //       UserEnum.OPERATION_SUPERVISOR,
      //       UserEnum.CUSTOMER_SERVICE,
      //       UserEnum.MANIFESTER,
      //       UserEnum.ADMIN,
      //       UserEnum.SALES_PERSON,
      //       UserEnum.SALES_MANAGER,
      //       UserEnum.FINANCE,
      //       UserEnum.DATA_ANALYST,
      //       UserEnum.FLEET_SUPERVISOR,
      //       UserEnum.OPERATION_CS_SUPERVISOR,
      //       UserEnum.OPERATION_STAFF,
      //       UserEnum.OPERATOR_CASH_COLLECTOR,
      //       UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
      //       UserEnum.CSV,
      //       UserEnum.OPS_MANAGER,
      //       UserEnum.FINANCE_CONTROLLER,
      //       UserEnum.DATA_LOGGER,
      //       UserEnum.QUOTATION,
      //       UserEnum.CUSTOMER_CARE,
      //       UserEnum.OCC_SOLUTION,
      //       UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
      //       UserEnum.OPS_CASH,
      //       UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
      //       UserEnum.GATEWAY_USER,
      //     ]
      //   ) || isMateenProdUser() || isShipmentSummaryTeam()),
      // },
      {
        label: 'Booking',
        key: getRandom(),
        path: '/booking',
        icon: <TbBrandBooking size={17} />,
        hidden: !isAccessible(
          [
            UserEnum.MANAGER,
            UserEnum.OPERATION_CS_SUPERVISOR,
            UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
            UserEnum.CSV,
            UserEnum.OPS_MANAGER,
            UserEnum.CUSTOMER_SERVICE,
            UserEnum.SALES_PERSON,
            UserEnum.SALES_MANAGER,
            UserEnum.SALES_DIRECTOR,
            // Changes to be made tomorrow
            UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
            UserEnum.CUSTOMER_CARE,
            UserEnum.DATA_ANALYST,
            UserEnum.OCC_SOLUTION,
            UserEnum.OPERATION_SUPERVISOR,
            UserEnum.OPERATION_STAFF,
            UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
          ],
          [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
        ),
      }, // remember to pass the key prop
      {
        label: 'Operations',
        key: getRandom(),
        path: '/operation',
        icon: <AiOutlineSolution size={18} />,
        hidden: !isAccessible(
          [
            UserEnum.MANAGER,
            UserEnum.OPS_MANAGER,
            UserEnum.DATA_ANALYST,
            UserEnum.OCC_SOLUTION,
            UserEnum.ADMIN,
            UserEnum.FINANCE,
            UserEnum.MANIFESTER,
            UserEnum.OPERATION_SUPERVISOR,
            UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
            UserEnum.FLEET_SUPERVISOR,
            UserEnum.OPERATION_CS_SUPERVISOR,
            UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
            UserEnum.OPERATION_STAFF,
            UserEnum.CUSTOMER_SERVICE,
            UserEnum.SALES_MANAGER,
            UserEnum.SALES_DIRECTOR,
            UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
            UserEnum.FINANCE_CONTROLLER,
          ],
          [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
        ),
      },
      {
        label: 'Tracking History',
        key: getRandom(),
        path: '/tracking-history',
        icon: <AiOutlineHistory size={18} />,
        hidden: !isAccessible(
          [
            UserEnum.ADMIN,
            UserEnum.FINANCE,
            UserEnum.FINANCE_CONTROLLER,
            UserEnum.OPERATION_SUPERVISOR,
            UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
            UserEnum.MANAGER,
            UserEnum.OPS_MANAGER,
            UserEnum.FLEET_SUPERVISOR,
            UserEnum.OPERATION_CS_SUPERVISOR,
            UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
            UserEnum.OPERATION_STAFF,
            UserEnum.MANIFESTER,
            UserEnum.DATA_ANALYST,
            UserEnum.OCC_SOLUTION,
            UserEnum.CUSTOMER_SERVICE,
            UserEnum.SALES_MANAGER,
            UserEnum.SALES_DIRECTOR,
            UserEnum.DATA_LOGGER,
            UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
            UserEnum.CUSTOMER_CARE,
          ],
          [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
        ),
      },
      {
        label: 'Geofencing',
        key: getRandom(),
        path: '/geofencing',
        icon: <FaMapMarkedAlt size={18} />,
        hidden: isProdMode()
          ? !isAccessible(GeoFencingAccess, [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE], true)
          : !isAccessible([UserEnum.MANAGER]),
      },
      {
        label: 'Marken Waybills',
        key: getRandom(),
        path: '/marken-table',
        icon: <TbSquareLetterM size={18} />,
        hidden: !(
          isMarkenTeam() ||
          isAccessible([UserEnum.GATEWAY_USER], [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA])
        ),
      },
      {
        label: 'Dispatch WorkStation',
        key: getRandom(),
        path: '/dispatch',
        icon: <AiOutlineSolution size={17} />,
        hidden: !isAccessible([
          UserEnum.OPERATION_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
          UserEnum.MANAGER,
          UserEnum.FLEET_SUPERVISOR,
          UserEnum.OPS_MANAGER,
          UserEnum.OPERATION_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR,
          UserEnum.OPERATION_STAFF,
          UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
          UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
        ]),
      },
      // { label: 'Reports', key: '21', path: '/reports', icon: <AiOutlineLineChart /> },
      {
        label: 'Trip Plan',
        key: getRandom(),
        icon: <BiTrip size={17} />,
        children: [
          {
            label: 'Trip Plan',
            key: getRandom(),
            path: '/trip/trip-plan',
            icon: <BiTrip size={17} />,
            hidden: !isAccessible([
              UserEnum.MANAGER,
              UserEnum.OPS_MANAGER,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
              UserEnum.FLEET_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
              UserEnum.OPERATION_STAFF,
              UserEnum.MANIFESTER,
              UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              UserEnum.DATA_ANALYST,
              UserEnum.OCC_SOLUTION,
            ]),
          },
          {
            label: 'FTL Trip Plan',
            key: getRandom(),
            path: '/ftl-trip-plan',
            icon: <RiTruckFill size={17} />,
            hidden: !isAccessible([
              UserEnum.MANAGER,
              UserEnum.OPS_MANAGER,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
              UserEnum.FLEET_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
              UserEnum.OPERATION_STAFF,
              UserEnum.MANIFESTER,
              UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              UserEnum.DATA_ANALYST,
              UserEnum.OCC_SOLUTION,
            ]),
          },
        ].map((item) => ({
          pathname: item?.path,
          name: item?.label,
          key: item?.key,
          label: item?.path ? (
            <NavLink to={item?.path} key={item?.key} replace>
              {item?.label}
            </NavLink>
          ) : (
            item?.label
          ),
          icon: item?.icon,
          hidden: item?.hidden,
        })),
        hidden: !isAccessible([
          UserEnum.MANAGER,
          UserEnum.OPS_MANAGER,
          UserEnum.OPERATION_SUPERVISOR,
          UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
          UserEnum.FLEET_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
          UserEnum.OPERATION_STAFF,
          UserEnum.MANIFESTER,
          UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
          UserEnum.DATA_ANALYST,
          UserEnum.OCC_SOLUTION,
        ]),
      },

      // {
      //   label: TRIP_PLAN_MENU,
      //   key: getRandom(),
      //   icon: <BiTrip size={17} />,
      //   hidden: !isProdMode() ?
      //     !isAccessible([
      //       UserEnum.MANAGER,
      //       UserEnum.OPS_MANAGER,
      //       UserEnum.OPERATION_SUPERVISOR,
      //       UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
      //       UserEnum.FLEET_SUPERVISOR,
      //       UserEnum.OPERATION_CS_SUPERVISOR,
      //       UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
      //       UserEnum.OPERATION_STAFF,
      //       UserEnum.MANIFESTER,
      //       UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
      //       UserEnum.DATA_ANALYST,
      //       UserEnum.OCC_SOLUTION,
      //     ]) :
      //     !isAccessible([Employee.MATEEN_PROD], [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE], true),
      // },
      {
        label: 'Waybill Exception',
        key: getRandom(),
        icon: <AiOutlineException size={17} />,
        children: [
          {
            label: 'Upload Exception Proof',
            key: getRandom(),
            path: '/waybill-exception',
            icon: <MdDriveFolderUpload size={17} />,
          },
          {
            label: 'OCC Exception Approval',
            key: getRandom(),
            path: '/occ-exception-list',
            icon: <LuPackageCheck size={17} />,
            hidden:
              !isAccessible([UserEnum.OCC_SOLUTION, UserEnum.CUSTOMER_CARE, UserEnum.CUSTOMER_SERVICE]) &&
              !isAccessible([Employee.MATEEN_PROD], [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE], true) &&
              !isAccessible(PRICING_TEAM_ACCESS, [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE], true),
          },
        ].map((item) => ({
          pathname: item?.path,
          name: item?.label,
          key: item?.key,
          label: item?.path ? (
            <NavLink to={item?.path} key={item?.key} replace>
              {item?.label}
            </NavLink>
          ) : (
            item?.label
          ),
          icon: item?.icon,
          hidden: item?.hidden,
        })),

        // hidden: !isAccessible([UserEnum.OPS_MANAGER]),
      },
      {
        label: 'Approval Screens',
        key: getRandom(),
        icon: <FcApproval size={17} />,
        // hidden: !isAccessible([UserEnum.OCC_SOLUTION, UserEnum.MANAGER, UserEnum.OPS_MANAGER]),
        children: [
          {
            label: 'Demurrage Charges',
            key: getRandom(),
            icon: <HiOutlineCash size={17} />,
            hidden: !(
              isAccessible([UserEnum.OCC_SOLUTION, UserEnum.CUSTOMER_CARE, UserEnum.CUSTOMER_SERVICE]) ||
              isAccessible([Employee.MATEEN_PROD], [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true) ||
              isAccessible(PRICING_TEAM_ACCESS, [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true) ||
              isAccessible(DEMURRAGE_OCC_APPROVAL_ACCESS, [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true)
            ),
            children: [
              {
                label: 'OCC Approval',
                key: getRandom(),
                path: '/demurrage-charges/occ-approval',
                icon: <LuPackageCheck size={17} />,
                hidden: !(
                  isAccessible([UserEnum.OCC_SOLUTION, UserEnum.CUSTOMER_CARE, UserEnum.CUSTOMER_SERVICE]) ||
                  isAccessible([Employee.MATEEN_PROD], [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true) ||
                  isAccessible(PRICING_TEAM_ACCESS, [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true) ||
                  isAccessible(DEMURRAGE_OCC_APPROVAL_ACCESS, [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true)
                ),
              },
            ].map((item) => ({
              pathname: item?.path,
              name: item?.label,
              key: item?.key,
              label: item?.path ? (
                <NavLink to={item?.path} key={item?.key} replace>
                  {item?.label}
                </NavLink>
              ) : (
                item?.label
              ),
              icon: item?.icon,
              hidden: item?.hidden,
            })),
          },
          {
            label: 'Volumetric',
            key: getRandom(),
            icon: <BsBox size={17} />,
            // hidden: !isAccessible([UserEnum.OCC_SOLUTION, UserEnum.MANAGER, UserEnum.OPS_MANAGER]),
            children: [
              {
                label: 'Approval Config',
                key: getRandom(),
                path: '/volumetric/approval-config',
                icon: <GrDocumentConfig size={17} />,
                hidden: !isAccessible([Employee.PANDI, Employee.MATEEN_PROD, Employee.ASIF_PATEL, Employee.SHIVRIN, Employee.MOHAMMED_LUQMAN], [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE], true),
              },
              {
                label: 'Volumetric Approval',
                key: getRandom(),
                path: '/volumetric/volumetric-approval',
                icon: <LuPackageCheck size={17} />,
                // hidden: !isAccessible([UserEnum.OCC_SOLUTION, UserEnum.MANAGER, UserEnum.OPS_MANAGER]),
              },
            ].map((item) => ({
              pathname: item?.path,
              name: item?.label,
              key: item?.key,
              label: item?.path ? (
                <NavLink to={item?.path} key={item?.key} replace>
                  {item?.label}
                </NavLink>
              ) : (
                item?.label
              ),
              icon: item?.icon,
              hidden: item?.hidden,
            })),
          },
        ].map((item: any) => ({
          pathname: item?.path,
          name: item?.label,
          key: item?.key,
          label: item?.path ? (
            <NavLink to={item?.path} key={item?.key} replace>
              {item?.label}
            </NavLink>
          ) : (
            item?.label
          ),
          icon: item?.icon,
          hidden: item?.hidden,
          children: item?.children,
        })),
      },
      {
        label: 'Trip',
        key: getRandom(),
        path: '/trip/trip-creation',
        icon: <BsTruck size={17} />,
        hidden: !isAccessible([
          UserEnum.MANAGER,
          UserEnum.OPS_MANAGER,
          UserEnum.OPERATION_SUPERVISOR,
          UserEnum.OPERATION_STAFF,
          UserEnum.FLEET_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
          UserEnum.MANIFESTER,
          UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
        ]),
      },
      {
        label: 'Temp Monitoring',
        key: getRandom(),
        path: '/temp-monitoring',
        icon: <MdOutlineDeviceThermostat size={18} />,
        hidden: !isAccessible([
          UserEnum.MANAGER,
          UserEnum.OPERATION_SUPERVISOR,
          UserEnum.ADMIN,
          UserEnum.SALES_MANAGER,
          UserEnum.SALES_DIRECTOR,
          UserEnum.FLEET_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR,
          UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
          UserEnum.OPS_MANAGER,
          UserEnum.FINANCE_CONTROLLER,
          UserEnum.FINANCE,
          UserEnum.DATA_ANALYST,
          UserEnum.OCC_SOLUTION,
        ]),
      },
      // { label: 'Dashboard', key: '23', path: '/dashboard', icon: <AiOutlineDashboard />},
      // { label: 'Users', key: '24', path: '/users', icon: <AiOutlineTeam /> },
      {
        label: 'Waybills',
        key: getRandom(),
        path: '/history',
        icon: <AiOutlineHistory size={17} />,
        hidden: !isAccessible([
          UserEnum.MANAGER,
          UserEnum.OPS_MANAGER,
          UserEnum.OPERATION_SUPERVISOR,
          UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
          UserEnum.FLEET_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
          UserEnum.OPERATION_STAFF,
          UserEnum.MANIFESTER,
          UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
        ]),
      },
      {
        label: 'Approved Waybills',
        key: getRandom(),
        path: '/approved-waybills',
        icon: <AiOutlineHistory size={17} />,
        hidden: !isAccessible([UserEnum.MANAGER, UserEnum.FINANCE]),
      },
      {
        label: 'Manual Waybills',
        key: getRandom(),
        path: '/manual-waybills',
        icon: <AiOutlineHistory size={17} />,
        hidden: !(
          isAccessible([UserEnum.MANAGER, UserEnum.DATA_LOGGER, UserEnum.SALES_PERSON, UserEnum.SALES_MANAGER, UserEnum.SALES_DIRECTOR]) ||
          isAccessible(
            [
              Employee.IMRAN_PASHA,
              Employee.VISHNU,
              Employee.MAHTAB_ALI,
              Employee?.MUZAMMIL_KHAN,
              Employee.ASRAF_ALI,
              Employee.IRSHAD_ALI_VELAPURATH,
              Employee.VIGNESHWARAN,
              Employee.ARCHE_MISRA,
              Employee.HAMMAD_MAROOF,
            ],
            [CountryEnum.KSA],
            true,
          )
        ),
      },
      {
        label: 'Delivery Sheet',
        key: getRandom(),
        path: '/deliverysheet',
        icon: <AiOutlineFileText size={17} />,
        hidden: !isAccessible(
          [
            UserEnum.MANAGER,
            UserEnum.OPS_MANAGER,
            UserEnum.OPERATION_SUPERVISOR,
            UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
            UserEnum.FLEET_SUPERVISOR,
            UserEnum.OPERATION_CS_SUPERVISOR,
            UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
            UserEnum.OPERATION_STAFF,
            UserEnum.MANIFESTER,
            UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
            UserEnum.OCC_SOLUTION,
          ],
          [CountryEnum.UAE, CountryEnum.KSA],
        ),
      },
      {
        label: 'Cash Collector',
        key: getRandom(),
        path: '/cash',
        icon: <HiOutlineCash size={18} />,
        hidden: !(
          isAccessible(
            [UserEnum.FINANCE, UserEnum.OPERATOR_CASH_COLLECTOR, UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR, UserEnum.OPERATION_SUPERVISOR],
            [CountryEnum.UAE, CountryEnum.KSA],
          ) ||
          isAccessible(
            [Employee.BANDER_ALLAFI, Employee.NOHA_KARKADAN],
            [CountryEnum.BAHRAIN, CountryEnum.KSA, CountryEnum.UAE],
            true,
          )
        ),
      },
      {
        label: 'FOD COD Cash Collector',
        key: getRandom(),
        path: '/fod-cod-cash',
        icon: <HiOutlineCash size={18} />,
        hidden: !(
          isAccessible(
            [UserEnum.FINANCE, UserEnum.OPERATOR_CASH_COLLECTOR, UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR, UserEnum.OPERATION_SUPERVISOR],
            [CountryEnum.UAE, CountryEnum.KSA],
          ) ||
          isAccessible(
            [Employee.BANDER_ALLAFI, Employee.NOHA_KARKADAN],
            [CountryEnum.BAHRAIN, CountryEnum.KSA, CountryEnum.UAE],
            true,
          )
        ),
      },
      {
        label: 'Bayan',
        key: getRandom(),
        path: '/bayan',
        icon: <BsReceiptCutoff size={18} />,
        hidden: !(
          isAccessible(
            [
              UserEnum.MANAGER,
              UserEnum.OPS_MANAGER,
              UserEnum.FLEET_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
              UserEnum.OPERATION_STAFF,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              UserEnum.OPS_CASH,
              UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
            ],
            [CountryEnum.BAHRAIN, CountryEnum.KSA, CountryEnum.UAE],
          ) ||
          isAccessible(
            [Employee.IMRAN_PASHA, Employee.SHIVRIN, Employee.MOHAMMED_LUQMAN],
            [CountryEnum.BAHRAIN, CountryEnum.KSA, CountryEnum.UAE],
            true,
          )
        ),
      },
      {
        label: 'Reports',
        key: getRandom(),
        path: '',
        icon: <HiOutlineDocumentReport size={17} />,
        hidden:
          !(
            isMarkenTeam() ||
            isAccessible([UserEnum.GATEWAY_USER], [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA])
          ) &&
          !isAccessible(PRICING_TEAM_ACCESS, [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE], true) &&
          !isAccessible(
            [
              UserEnum.MANAGER,
              UserEnum.OPS_MANAGER,
              UserEnum.MANIFESTER,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
              UserEnum.SALES_MANAGER,
              UserEnum.SALES_DIRECTOR,
              UserEnum.DATA_ANALYST,
              UserEnum.FLEET_SUPERVISOR,
              UserEnum.FINANCE,
              UserEnum.OPERATION_STAFF,
              UserEnum.OPERATION_CS_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
              UserEnum.FINANCE_CONTROLLER,
              UserEnum.OCC_SOLUTION,
              UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              UserEnum.CUSTOMER_CARE,
              UserEnum.IT_SUPPORT,

            ],
            [CountryEnum.UAE, CountryEnum.KSA, CountryEnum.BAHRAIN],
          ),
        // hidden: !isAccessible([UserEnum.MANAGER, UserEnum.OPS_MANAGER, UserEnum.MANIFESTER, UserEnum.OPERATION_SUPERVISOR, UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
        // UserEnum.DATA_ANALYST, UserEnum.FLEET_SUPERVISOR, UserEnum.FINANCE, UserEnum.OPERATION_STAFF, UserEnum.OPERATION_CS_SUPERVISOR], [CountryEnum.UAE, CountryEnum.KSA]),
        children: [
          {
            label: 'Booking Report',
            key: getRandom(),
            path: '/booking-report',
            icon: <TbBrandBooking size={17} />,
            hidden: !isAccessible([
              UserEnum.DATA_ANALYST,
              UserEnum.OCC_SOLUTION,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
              UserEnum.SALES_MANAGER,
              UserEnum.SALES_DIRECTOR,
              UserEnum.MANAGER,
              UserEnum.OPS_MANAGER,
              UserEnum.MANIFESTER,
              UserEnum.FLEET_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
              UserEnum.OPERATION_STAFF,
              UserEnum.OPS_MANAGER,
              UserEnum.OPERATION_STAFF,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              UserEnum.CUSTOMER_CARE,
            ]),
          },
          {
            label: 'Daily Recap Report',
            key: getRandom(),
            path: '/operation-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !isAccessible(
              [
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.MANIFESTER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.FINANCE,
                UserEnum.FINANCE_CONTROLLER,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.CUSTOMER_CARE,
              ],
              [CountryEnum.UAE, CountryEnum.KSA, CountryEnum.BAHRAIN],
            ),
          },
          {
            label: 'Employee Report',
            key: getRandom(),
            path: '/employee-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible(
              [
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.MANIFESTER,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ],
              [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
            ),
          },
          {
            label: 'Not Delivery Report',
            key: getRandom(),
            path: '/not-delivery-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible(
              [
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.MANIFESTER,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.CUSTOMER_CARE,
              ],
              [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
            ),
          },
          {
            label: 'RTO Report',
            key: getRandom(),
            path: '/rto-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible(
              [
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.MANIFESTER,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ],
              [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
            ),
          },
          {
            label: 'Trip plan Report',
            key: getRandom(),
            path: '/trip-plan-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible(
              [
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.MANIFESTER,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.FINANCE_CONTROLLER,
                UserEnum.FINANCE,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.CUSTOMER_CARE,
              ],
              [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
            ),
          },
          {
            label: 'Tripplan Waybill Report',
            key: getRandom(),
            path: '/trip-waybill-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible(
              [
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.MANIFESTER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.CUSTOMER_CARE,
              ],
              [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
            ),
          },
          // {
          //     label: 'Customer Report', key: 64, path: '/customer-report', icon: <AiOutlineSolution size={18} />,
          //     hidden: !isAccessibleByEmployeeId([Employee.MATEEN_PROD,Employee.ALANOUD, Employee.ARWA, Employee.BALA, Employee.PANDI])
          //     //hidden: true
          // },
          {
            label: 'Delivery Sheet Report',
            key: getRandom(),
            path: '/delivery-sheet-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible(
              [
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.MANIFESTER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ],
              [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
            ),
          },
          {
            label: 'Vehicle Report',
            key: getRandom(),
            path: '/vehicle-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible(
              [
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.MANIFESTER,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.FINANCE,
                UserEnum.FINANCE_CONTROLLER,
              ],
              [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
            ),
          },
          // LIMITED ACCESS REPORT
          {
            label: 'Not Manifested Report',
            key: getRandom(),
            path: '/not-manifest-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !isAccessible([
              UserEnum.MANIFESTER,
              UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
              UserEnum.MANAGER,
              UserEnum.ADMIN,
            ]),
          },
          {
            label: 'Manifest Charge Report',
            key: getRandom(),
            path: '/manifest-charge-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !(
              isAccessible([
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.MANIFESTER,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.ADMIN,
                UserEnum.FINANCE_CONTROLLER,
                UserEnum.FINANCE,
                UserEnum.CUSTOMER_CARE,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.SALES_PERSON,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
              ]) || isAccessible([Employee.IMATHUL_RAFI_KSA, Employee.MOHAMMAD_FAIZAN_ALAM], [CountryEnum.KSA], true)
            ),
          },
          {
            label: 'Finance Manifest Report',
            key: getRandom(),
            path: '/finance-manifest-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !(
              isAccessible(
                [
                  UserEnum.DATA_ANALYST,
                  UserEnum.OCC_SOLUTION,
                  UserEnum.FINANCE,
                  UserEnum.MANIFESTER,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANAGER,
                  UserEnum.ADMIN,
                  UserEnum.FINANCE_CONTROLLER,
                ],
                [CountryEnum.UAE, CountryEnum.KSA, CountryEnum.BAHRAIN],
              ) || isAccessible([Employee.IMATHUL_RAFI], [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE], true)
            ),
            //hidden: true
          },

          {
            label: 'Finance Manifest With Vehicles Report',
            key: getRandom(),
            path: '/finance-manifest-with-vehicles-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !(
              isAccessible(
                [
                  UserEnum.DATA_ANALYST,
                  UserEnum.FINANCE,
                  UserEnum.MANIFESTER,
                  UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                  UserEnum.MANAGER,
                  UserEnum.ADMIN,
                  UserEnum.FINANCE_CONTROLLER,
                ],
                [CountryEnum.UAE, CountryEnum.KSA, CountryEnum.BAHRAIN],
              ) || isAccessible([Employee.IMATHUL_RAFI], [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE], true)
            ),
            //hidden: true
          },

          {
            label: 'Locate Shipment Report',
            key: getRandom(),
            path: '/locate-shipment',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible(
              [
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.MANIFESTER,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.CUSTOMER_CARE,
              ],
              [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
            ),
          },
          {
            label: 'Cash Collection Report',
            key: getRandom(),
            path: '/cash-collection-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible(
              [
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.MANAGER,
                UserEnum.FINANCE,
                UserEnum.FINANCE_CONTROLLER,
              ],
              [CountryEnum.UAE, CountryEnum.KSA, CountryEnum.BAHRAIN],
            ),
          },
          {
            label: 'WB wise fleet details Report',
            key: getRandom(),
            path: '/wb-wise-fleet-details-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible(
              [
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.MANIFESTER,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ],
              [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
            ),
          },
          {
            label: 'POD Availability Report',
            key: getRandom(),
            path: '/pod-availability-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible(
              [
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.MANIFESTER,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.CUSTOMER_CARE,
              ],
              [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
            ),
          },
          {
            label: 'Exemption Report',
            key: getRandom(),
            path: '/exemption-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible(
              [
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.MANIFESTER,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ],
              [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
            ),
          },
          {
            label: 'PFN Report',
            key: getRandom(),
            path: '/pfn-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible(
              [
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.MANIFESTER,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ],
              [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
            ),
          },
          {
            label: 'Customer Report',
            key: getRandom(),
            path: '/customer-info-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible(
              [...PRICING_TEAM_ACCESS, Employee.ARWA, Employee.BALA, Employee.PANDI, Employee.PRANEETH],
              [CountryEnum.KSA],
              true,
            ),
          },
          {
            label: 'Marken Report',
            key: getRandom(),
            path: '/marken-report',
            icon: <AiOutlineSolution size={18} />,
            hidden:
              !(
                isMarkenTeam() ||
                isAccessible([UserEnum.GATEWAY_USER], [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA])
              ) &&
              !isAccessible([
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.MANIFESTER,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ]),
          },
          {
            label: 'Daily Activity Recap Report',
            key: getRandom(),
            path: '/daily-activity-recap-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible(
              [
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.MANIFESTER,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.CUSTOMER_CARE,
              ],
              [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
            ),
          },
          {
            label: 'Delivery SLR Report',
            key: getRandom(),
            path: '/delivery-slr-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !(
              isAccessible(
                [
                  Employee.BALA,
                  Employee.ANIS_BISWAS,
                  Employee.GOIUSE,
                  Employee.PANDI,
                  Employee.TURKI_ALBUWAYDI,
                  Employee.Muath_Al_Abdulmunem, 
                  Employee.MAJAD_ALI,
                  Employee.SHIVRIN, Employee.MOHAMMED_LUQMAN,
                  Employee.BIJOY,
                  Employee.SHAJAHAN_SHAMSUDEEN,
                  Employee.ASIF_PATEL,
                  Employee.MAHTAB_ALI,
                  Employee?.MUZAMMIL_KHAN,
                  Employee.PRASANTH_RAMACHANDRAN,
                  Employee.MOHAMED_RIYAS,
                  Employee.IRSHAD_ALI_VELAPURATH,
                  Employee.MOHAMMED_ALJOHANI,
                  Employee.PRANEETH
                ],
                [CountryEnum.KSA],
                true,
              ) || isAccessible([UserEnum.OCC_SOLUTION])
            ),
          },
          {
            label: 'Miss Pickup Report',
            key: getRandom(),
            path: '/miss-pickup-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !(
              isAccessible(
                [
                  Employee.BALA,
                  Employee.ANIS_BISWAS,
                  Employee.GOIUSE,
                  Employee.PANDI,
                  Employee.TURKI_ALBUWAYDI,
                  Employee.Muath_Al_Abdulmunem,
                  Employee.MAJAD_ALI,
                  Employee.SHIVRIN, Employee.MOHAMMED_LUQMAN,
                  Employee.BIJOY,
                  Employee.SHAJAHAN_SHAMSUDEEN,
                  Employee.ASIF_PATEL,
                  Employee.MAHTAB_ALI,
                  Employee?.MUZAMMIL_KHAN,
                  Employee.PRASANTH_RAMACHANDRAN,
                  Employee.MOHAMED_RIYAS,
                  Employee.IRSHAD_ALI_VELAPURATH,
                  Employee.MOHAMMED_ALJOHANI,
                  Employee.PRANEETH,
                  Employee.KRISHAN_THRIPURA,
                ],
                [CountryEnum.KSA],
                true,
              ) || isAccessible([UserEnum.OCC_SOLUTION])
            ),
          },
          {
            label: 'Marken Client Report',
            key: getRandom(),
            path: '/marken-client-report',
            icon: <AiOutlineSolution size={18} />,
            hidden:
              !(
                isMarkenTeam() ||
                isAccessible([UserEnum.GATEWAY_USER], [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA])
              ) &&
              !isAccessible([
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.MANIFESTER,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ]),
          },
          {
            label: 'Marken KPI Report',
            key: getRandom(),
            path: '/marken-kpi-report',
            icon: <AiOutlineSolution size={18} />,
            hidden:
              !(
                isMarkenTeam() ||
                isAccessible([UserEnum.GATEWAY_USER], [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA])
              ) &&
              !isAccessible([
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.MANIFESTER,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ]),
          },
          {
            label: 'Waybills Not Delivered',
            key: getRandom(),
            path: '/waybills-not-delivered-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible([
              UserEnum.DATA_ANALYST,
              UserEnum.OCC_SOLUTION,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
              UserEnum.MANIFESTER,
              UserEnum.MANAGER,
              UserEnum.OPS_MANAGER,
              UserEnum.FLEET_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
              UserEnum.OPS_MANAGER,
              UserEnum.OPERATION_STAFF,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
            ]),
          },
          {
            label: 'Waybills Not Invoiced',
            key: getRandom(),
            path: '/waybills-not-invoiced-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible([
              UserEnum.DATA_ANALYST,
              UserEnum.OCC_SOLUTION,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
              UserEnum.MANIFESTER,
              UserEnum.MANAGER,
              UserEnum.OPS_MANAGER,
              UserEnum.FLEET_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
              UserEnum.OPS_MANAGER,
              UserEnum.OPERATION_STAFF,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
            ]),
          },
          {
            label: 'Customer Complaint Report',
            key: getRandom(),
            path: '/customer-complaint-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible([
              UserEnum.DATA_ANALYST,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
              UserEnum.MANIFESTER,
              UserEnum.MANAGER,
              UserEnum.OPS_MANAGER,
              UserEnum.FLEET_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
              UserEnum.OPS_MANAGER,
              UserEnum.OPERATION_STAFF,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.SALES_MANAGER,
              UserEnum.SALES_DIRECTOR,
              UserEnum.CUSTOMER_SERVICE,
              UserEnum.OCC_SOLUTION,
              UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              UserEnum.CUSTOMER_CARE,
            ]),
          },
          {
            label: 'Customer Complaint KPI Report',
            key: getRandom(),
            path: '/customer-complaint-kpi-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible([
              UserEnum.DATA_ANALYST,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
              UserEnum.MANIFESTER,
              UserEnum.MANAGER,
              UserEnum.OPS_MANAGER,
              UserEnum.FLEET_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
              UserEnum.OPS_MANAGER,
              UserEnum.OPERATION_STAFF,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.SALES_MANAGER,
              UserEnum.SALES_DIRECTOR,
              UserEnum.CUSTOMER_SERVICE,
              UserEnum.OCC_SOLUTION,
              UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              UserEnum.CUSTOMER_CARE,
            ]),
          },
          {
            label: 'Scan Performance Report',
            key: getRandom(),
            path: '/scan-performance-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible(
              [
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.MANIFESTER,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.CUSTOMER_CARE,
              ],
              [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
            ),
          },
          {
            label: 'Vehicle Tracking Report',
            key: getRandom(),
            path: '/vehicle-tracking-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible([
              UserEnum.DATA_ANALYST,
              UserEnum.MANAGER,
              UserEnum.OPS_MANAGER,
              UserEnum.FLEET_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
              UserEnum.OPS_MANAGER,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.OCC_SOLUTION,
              UserEnum.CUSTOMER_CARE,
              // UserEnum.OPERATION_SUPERVISOR_CUSTOMER_SERVICE,
            ]),
          },
          {
            label: 'Driver Tracking Report',
            key: getRandom(),
            path: '/meta-driver-tracking-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: false,
          },
          {
            label: 'IRS Manifest Approval Report',
            key: getRandom(),
            path: '/irs-manifest-approval-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !isAccessible([
              UserEnum.DATA_ANALYST,
              UserEnum.OCC_SOLUTION,
              UserEnum.MANIFESTER,
              UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
              UserEnum.MANAGER,
              UserEnum.OPS_MANAGER,
              UserEnum.ADMIN,
              UserEnum.FINANCE_CONTROLLER,
              UserEnum.FINANCE,
            ]),
          },
          {
            label: 'POD Barcode Report',
            key: getRandom(),
            path: '/pod-barcode-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible([
              UserEnum.DATA_ANALYST,
              UserEnum.OCC_SOLUTION,
              UserEnum.MANAGER,
              UserEnum.OPS_MANAGER,
              UserEnum.FLEET_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
              UserEnum.OPS_MANAGER,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.OCC_SOLUTION,
              // UserEnum.OPERATION_SUPERVISOR_CUSTOMER_SERVICE,
            ]),
          },
          {
            label: 'Oracle Pushed Waybill Report (3 months)',
            key: getRandom(),
            path: '/meta-picking-to-oracle-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !isAccessible([
              UserEnum.FINANCE_CONTROLLER,
              UserEnum.FINANCE,
              UserEnum.MANIFESTER,
              UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
            ]),
          },

          {
            label: 'FFD Booking Report',
            key: getRandom(),
            path: '/ffd-booking-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible(
              [
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.SALES_MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.MANIFESTER,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.CUSTOMER_CARE,
              ],
              [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
            ),
          },

          {
            label: 'Cash,FOD and COD Report',
            key: getRandom(),
            path: '/fod-cod-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !isAccessible(
              [
                // UserEnum.DATA_ANALYST,
                // UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                // UserEnum.SALES_MANAGER,
                // UserEnum.MANIFESTER,
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                // UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPS_MANAGER,
                // UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                // UserEnum.FINANCE,
                // UserEnum.FINANCE_CONTROLLER,
                UserEnum.IT_SUPPORT,
              ],
              [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
            ),
          },
          {
            label: 'Agreement Report',
            key: getRandom(),
            path: '/meta-agreement-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !(
              isAccessible(
                [
                  UserEnum.FINANCE,
                  UserEnum.ADMIN,
                  UserEnum.FINANCE_CONTROLLER,
                ],
                [CountryEnum.UAE, CountryEnum.KSA, CountryEnum.BAHRAIN],
              ) || isAccessible([Employee.ALANOUD, Employee.GOPINATH, ...PRICING_TEAM_ACCESS], [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE], true)
            ),
          },
          {
            label: 'POD Agreement Report',
            key: getRandom(),
            path: '/meta-pod-agreement-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !isAccessible(PRICING_TEAM_ACCESS, [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE], true),
          },


          {
            label: 'Manifestation IRS report',
            key: getRandom(),
            path: '/meta-manifestation-irs-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !(
              isAccessible(
                [
                  UserEnum.ADMIN,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                ],
                [CountryEnum.UAE, CountryEnum.KSA, CountryEnum.BAHRAIN],
              ) || isAccessible([Employee.MATEEN_PROD,
              Employee.HASSAN_ALMIRZA,
              Employee.GOPINATH
              ], [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE], true)
            ),
          },

        ].map((item) => {
          return {
            pathname: item?.path,
            name: item?.label,
            key: item?.key,
            label: item?.path ? (
              <NavLink to={item?.path} key={item?.key} reloadDocument={false} replace>
                {item?.label}
              </NavLink>
            ) : (
              item?.label
            ),
            icon: item?.icon,
            hidden: item?.hidden,
          };
        }),
      },
      {
        label: 'Analytical Reports',
        key: getRandom(),
        path: '',
        icon: <HiOutlineDocumentReport size={17} />,
        hidden: !isAccessible(
          [
            UserEnum.OPS_MANAGER,
            UserEnum.OPERATION_SUPERVISOR,
            UserEnum.OPERATION_STAFF,
            UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
            UserEnum.OPERATION_CS_SUPERVISOR,
            UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
            UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
            UserEnum.OPS_CASH,
            UserEnum.OPERATOR_CASH_COLLECTOR,
            UserEnum.MANAGER,
            UserEnum.OCC_SOLUTION,
            UserEnum.CUSTOMER_CARE,
            UserEnum.FINANCE,
            UserEnum.FINANCE_CONTROLLER,
          ],
          [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
        ),
        children: [
          {
            label: 'First Mile Report',
            key: getRandom(),
            path: '/meta-first-mile-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !(
              isAccessible([
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.OPS_CASH,
                UserEnum.OPERATOR_CASH_COLLECTOR,
                UserEnum.MANAGER,
                UserEnum.OCC_SOLUTION,
                UserEnum.CUSTOMER_CARE,
              ]) || isAccessible([Employee.MATEEN_PROD], [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true)
            ),
          },
          {
            label: 'Middle Mile Report',
            key: getRandom(),
            path: '/meta-middle-mile-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !(
              isAccessible([
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.OPS_CASH,
                UserEnum.OPERATOR_CASH_COLLECTOR,
                UserEnum.MANAGER,
                UserEnum.OCC_SOLUTION,
                UserEnum.CUSTOMER_CARE,
              ]) || isAccessible([Employee.MATEEN_PROD], [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true)
            ),
          },
          {
            label: 'Last Mile Report',
            key: getRandom(),
            path: '/meta-last-mile-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !(
              isAccessible([
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.OPS_CASH,
                UserEnum.OPERATOR_CASH_COLLECTOR,
                UserEnum.MANAGER,
                UserEnum.OCC_SOLUTION,
                UserEnum.CUSTOMER_CARE,
              ]) || isAccessible([Employee.MATEEN_PROD], [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true)
            ),
          },
          {
            label: 'In Transit Pending Report',
            key: getRandom(),
            path: '/meta-in-transit-pending-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !(
              isAccessible([
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.OPS_CASH,
                UserEnum.OPERATOR_CASH_COLLECTOR,
                UserEnum.MANAGER,
                UserEnum.OCC_SOLUTION,
                UserEnum.CUSTOMER_CARE,
              ]) || isAccessible([Employee.MATEEN_PROD], [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true)
            ),
          },
          // {
          //   label: "Box Utilization Report",
          //   key: getRandom(),
          //   path: "/meta-box-utilization-report",
          //   icon: <AiOutlineSolution size={17} />,
          //   hidden: !(isAccessible([
          //     UserEnum.OPS_MANAGER,
          //     UserEnum.OPERATION_SUPERVISOR,
          //     UserEnum.OPERATION_STAFF,
          //     UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
          //     UserEnum.OPERATION_CS_SUPERVISOR,
          //     UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
          //     UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
          //     UserEnum.OPS_CASH,
          //     UserEnum.OPERATOR_CASH_COLLECTOR,
          //     UserEnum.MANAGER,
          //     UserEnum.OCC_SOLUTION,
          //     UserEnum.CUSTOMER_CARE,
          //   ]) || isAccessible(
          //     [Employee.MATEEN_PROD],
          //     [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN],
          //     true
          //   )),
          // },
          // {
          //   label: 'Trip Plan Status Report',
          //   key: getRandom(),
          //   path: '/meta-trip-plan-status-report',
          //   icon: <AiOutlineSolution size={17} />,
          //   hidden: !(
          //     isAccessible([
          //       UserEnum.OPS_MANAGER,
          //       UserEnum.OPERATION_SUPERVISOR,
          //       UserEnum.OPERATION_STAFF,
          //       UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
          //       UserEnum.OPERATION_CS_SUPERVISOR,
          //       UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
          //       UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
          //       UserEnum.OPS_CASH,
          //       UserEnum.OPERATOR_CASH_COLLECTOR,
          //       UserEnum.MANAGER,
          //       UserEnum.OCC_SOLUTION,
          //       UserEnum.CUSTOMER_CARE,
          //     ]) || isAccessible([Employee.MATEEN_PROD], [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true)
          //   ),
          // },
          {
            label: 'FTL Ideal Vehicle Report',
            key: getRandom(),
            path: '/meta-ftl-ideal-vehicle-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !(
              isAccessible([
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.OPS_CASH,
                UserEnum.OPERATOR_CASH_COLLECTOR,
                UserEnum.MANAGER,
                UserEnum.OCC_SOLUTION,
                UserEnum.CUSTOMER_CARE,
              ]) || isAccessible([Employee.MATEEN_PROD], [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true)
            ),
          },
          {
            label: 'Daily Scan Report',
            key: getRandom(),
            path: '/meta-daily-scan-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !(
              isAccessible([
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.OPS_CASH,
                UserEnum.OPERATOR_CASH_COLLECTOR,
                UserEnum.MANAGER,
                UserEnum.OCC_SOLUTION,
                UserEnum.CUSTOMER_CARE,
              ]) || isAccessible([Employee.MATEEN_PROD], [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true)
            ),
          },
          {
            label: 'Fleet Utilization Report',
            key: getRandom(),
            path: '/meta-fleet-utilization-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !(
              isAccessible([
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.OPS_CASH,
                UserEnum.OPERATOR_CASH_COLLECTOR,
                UserEnum.MANAGER,
                UserEnum.OCC_SOLUTION,
                UserEnum.CUSTOMER_CARE,
              ]) || isAccessible([Employee.MATEEN_PROD], [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true)
            ),
          },
          {
            label: 'Local Vehicle Utilization',
            key: getRandom(),
            path: '/meta-vehicle-utilization-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !(
              isAccessible([
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.OPS_CASH,
                UserEnum.OPERATOR_CASH_COLLECTOR,
                UserEnum.MANAGER,
                UserEnum.OCC_SOLUTION,
                UserEnum.CUSTOMER_CARE,
                UserEnum.FINANCE_CONTROLLER,
              ]) || isAccessible([Employee.MATEEN_PROD], [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true)
            ),
          },
          {
            label: 'Customer Shipper Coordinates Report',
            key: getRandom(),
            path: '/meta-customer-shipper-coordinates-report',
            icon: <AiOutlineSolution size={17} />,
          },
          {
            label: 'Customer Consignee Coordinates Report',
            key: getRandom(),
            path: '/meta-customer-consignee-coordinates-report',
            icon: <AiOutlineSolution size={17} />,
          },
          {
            label: 'GPI FSC Impact Report',
            key: getRandom(),
            path: '/meta-gpi-fsc-impact-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !isAccessible([UserEnum.MANAGER, UserEnum.FINANCE, UserEnum.FINANCE_CONTROLLER]),
          },
          {
            label: 'Handover Sheet Report',
            key: getRandom(),
            path: '/meta-handover-sheet-report',
            icon: <AiOutlineSolution size={17} />,
          },
          {
            label: 'Manifest Confirmation Pending Report',
            key: getRandom(),
            path: '/meta-manifest-confirmation-pending-report',
            icon: <AiOutlineSolution size={17} />,
          },
          {
            label: 'Trip-Pallet Utilization Report',
            key: getRandom(),
            path: '/meta-trip-pallet-utilization-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !(
              isAccessible([
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.OPS_CASH,
                UserEnum.OPERATOR_CASH_COLLECTOR,
                UserEnum.MANAGER,
                UserEnum.OCC_SOLUTION,
                UserEnum.CUSTOMER_CARE,
                UserEnum.FINANCE_CONTROLLER,
              ]) || isAccessible([Employee.MATEEN_PROD], [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true)
            ),
          },
          {
            label: 'Absence of Short Address / Incomplete Address Report',
            key: getRandom(),
            path: '/meta-booking-national-address-report',
            icon: <AiOutlineSolution size={17} />,
          },
          {
            label: 'Courier Trip Stops Report',
            key: getRandom(),
            path: '/meta-courier-trip-stops-report',
            icon: <AiOutlineSolution size={17} />,
          },
          {
            label: 'Idle severity report',
            key: getRandom(),
            path: '/meta-idle-severity-report',
            icon: <AiOutlineSolution size={17} />,
          },
          {
            label: 'Vehicle Login & Logout Data Report',
            key: getRandom(),
            path: '/meta-vehicle-login-logout-data-report',
            icon: <AiOutlineSolution size={17} />,
          },
          {
            label: 'Shipper & Consignee Waiting Time Report',
            key: getRandom(),
            path: '/meta-shipper-consignee-waiting-time-report',
            icon: <AiOutlineSolution size={17} />,
          },
          {
            label: 'Pickup/Delivery scan at Hub Report',
            key: getRandom(),
            path: '/meta-event-at-hub-scan-report',
            icon: <AiOutlineSolution size={17} />,
          },
          {
            label: 'Suspicious Scan Report',
            key: getRandom(),
            path: '/meta-suspicious-scan-report',
            icon: <AiOutlineSolution size={17} />,
          },
          {
            label: 'Out-of-Location Shipment Scan Report',
            key: getRandom(),
            path: '/meta-out-of-location-shipment-scan-report',
            icon: <AiOutlineSolution size={17} />,
          },
        ].map((item) => ({
          pathname: item?.path,
          name: item?.label,
          key: item?.key,
          label: item?.path ? (
            <NavLink to={item?.path} key={item?.key} replace>
              {item?.label}
            </NavLink>
          ) : (
            item?.label
          ),
          icon: item?.icon,
          hidden: item?.hidden,
        })),
      },
      {
        label: 'Vehicle Report',
        key: getRandom(),
        icon: <FaTruckMoving size={17} />,
        hidden: !(
          isAccessible([
            UserEnum.OPS_MANAGER,
            UserEnum.OPERATION_SUPERVISOR,
            UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
            UserEnum.OPERATION_CS_SUPERVISOR,
            UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
            UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
            UserEnum.MANAGER,
            UserEnum.OPERATION_STAFF,
          ]) || isAccessible([Employee.MATEEN_PROD], [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true)
        ),
        children: [
          {
            label: 'Vehicle GPS History Report',
            key: getRandom(),
            path: '/vehicle-gps-history-report',
            icon: <AiOutlineSolution size={18} />,
            hidden: !(
              isAccessible([
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.MANAGER,
              ]) || isAccessible([Employee.MATEEN_PROD], [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true)
            ),
          },

          {
            label: 'Vehicle Loading Unloading Report',
            key: getRandom(),
            path: '/vehicle-loading-unloading-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !(
              isAccessible([
                UserEnum.OPS_MANAGER,
                UserEnum.MANAGER,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ]) || isAccessible([Employee.MATEEN_PROD], [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true)
            ),
          },
        ].map((item) => ({
          pathname: item?.path,
          name: item?.label,
          key: item?.key,
          label: item?.path ? (
            <NavLink to={item?.path} key={item?.key} replace>
              {item?.label}
            </NavLink>
          ) : (
            item?.label
          ),
          icon: item?.icon,
          hidden: item?.hidden,
        })),
      },
      {
        label: 'Pallet',
        key: getRandom(),
        path: '/pallet',
        icon: <FaPallet size={17} />,
        hidden: !isAccessible([
          UserEnum.MANAGER,
          UserEnum.OPS_MANAGER,
          UserEnum.OPERATION_SUPERVISOR,
          UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
          UserEnum.FLEET_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
          UserEnum.OPERATION_STAFF,
          UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
        ]),
      },
      {
        label: 'Pre-load Pallet',
        key: getRandom(),
        path: '/pre-load-pallet',
        icon: <FaTruckLoading size={17} />,
        hidden: !isAccessible([
          UserEnum.MANAGER,
          UserEnum.OPS_MANAGER,
          UserEnum.OPERATION_SUPERVISOR,
          UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
          UserEnum.FLEET_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
          UserEnum.OPERATION_STAFF,
          UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
        ]),
      },
      {
        label: 'Customer',
        key: getRandom(),
        path: '/customer',
        icon: <AiOutlineUser size={17} />,
        hidden: !(
          isEmpLuqman ||
          isAccessible(
            [
              UserEnum.MANAGER,
              UserEnum.OPS_MANAGER,
              UserEnum.FINANCE,
              UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.FINANCE_CONTROLLER,
              UserEnum.MANIFESTER,
              UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
              UserEnum.DATA_ANALYST,
              UserEnum.OCC_SOLUTION,
              UserEnum.CSV,
              UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
            ],
            [CountryEnum.UAE, CountryEnum.KSA, CountryEnum.BAHRAIN],
          )
        ),
        //[UserEnum.FINANCE, UserEnum.DATA_ANALYST, UserEnum.MANAGER, UserEnum.OPERATION_SUPERVISOR
      },
      {
        label: 'Credit Limit',
        key: getRandom(),
        icon: <AiOutlineDollar size={17} />,
        hidden: !isAccessible([
          UserEnum.MANAGER,
          UserEnum.SALES_MANAGER,
          UserEnum.SALES_DIRECTOR,
          UserEnum.SALES_PERSON,
        ]),
        children: [
          {
            label: 'Customers To Be Blocked',
            key: getRandom(),
            path: '/credit-limit-extension',
            icon: <AiOutlineDollar size={17} />,
            hidden: !isAccessible([
              UserEnum.MANAGER,
              UserEnum.SALES_MANAGER,
              UserEnum.SALES_DIRECTOR,
              UserEnum.SALES_PERSON,
            ]),
          },
          {
            label: 'Extension Requests',
            key: getRandom(),
            path: '/credit-limit-extension-requests',
            icon: <AiOutlineSolution size={17} />,
            hidden: !isAccessible([
              UserEnum.MANAGER,
              UserEnum.SALES_MANAGER,
              UserEnum.SALES_DIRECTOR,
              UserEnum.SALES_PERSON,
            ]),
          },
        ].map((item) => ({
          pathname: item?.path,
          name: item?.label,
          key: item?.key,
          label: item?.path ? (
            <NavLink to={item?.path} key={item?.key} replace>
              {item?.label}
            </NavLink>
          ) : (
            item?.label
          ),
          icon: item?.icon,
          hidden: item?.hidden,
        })),
      },
      {
        label: 'POD',
        key: getRandom(),
        icon: <AiOutlineDeliveredProcedure size={17} />,
        hidden: !(
          isAccessible([
            UserEnum.MANAGER,
            UserEnum.OPS_MANAGER,
            UserEnum.OPERATION_SUPERVISOR,
            UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
            UserEnum.OPERATION_CS_SUPERVISOR,
            UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
            UserEnum.MANIFESTER,
            UserEnum.OPERATION_STAFF,
            UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
            UserEnum.SALES_PERSON,
          ]) || PodDownloadAccess
        ),
        children: [
          {
            label: 'Proof of Delivery (POD)',
            key: getRandom(),
            path: '/pod',
            icon: <AiOutlineDeliveredProcedure size={17} />,
            hidden: !(
              isAccessible([
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.MANIFESTER,
                UserEnum.OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.SALES_PERSON,
              ]) || PodDownloadAccess
            ),
          },
          {
            label: 'Pending POD',
            key: getRandom(),
            path: '/pending-pod',
            icon: <AiOutlineDeliveredProcedure size={17} />,
            hidden: !isAccessible([
              UserEnum.MANAGER,
              UserEnum.OPS_MANAGER,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
              UserEnum.OPERATION_CS_SUPERVISOR,
              UserEnum.MANIFESTER,
              UserEnum.OPERATION_STAFF,
              UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              UserEnum.SALES_PERSON,
            ]),
          },
        ].map((item) => ({
          pathname: item?.path,
          name: item?.label,
          key: item?.key,
          label: item?.path ? (
            <NavLink to={item?.path} key={item?.key} replace>
              {item?.label}
            </NavLink>
          ) : (
            item?.label
          ),
          icon: item?.icon,
          hidden: item?.hidden,
        })),
      },
      {
        label: 'POD Dispatch',
        key: getRandom(),
        path: '/pod-dispatch',
        icon: <AiOutlineDeliveredProcedure size={17} />,
        hidden: !isAccessible([
          UserEnum.MANAGER,
          UserEnum.OPS_MANAGER,
          UserEnum.OPERATION_SUPERVISOR,
          UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
          UserEnum.OPERATION_CS_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
          UserEnum.MANIFESTER,
          UserEnum.OPERATION_STAFF,
          UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
        ]),
      },
      {
        label: 'Approval Manifest',
        key: getRandom(),
        path: '',
        icon: <AiOutlineSolution size={18} />,
        hidden: !(
          isAccessible(
            [
              UserEnum.MANAGER,
              UserEnum.OPS_MANAGER,
              UserEnum.SALES_PERSON,
              UserEnum.FINANCE_CONTROLLER,
              UserEnum.SALES_MANAGER,
              UserEnum.SALES_DIRECTOR,
            ],
            [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN],
          ) ||
          isAccessible([Employee.LARA, Employee.HALA], [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true)
        ),
        children: [
          // {
          //     label: 'Domestic Manifest',
          //     key: 72,
          //     path: '/sales-man-manifest',
          //     icon: <AiOutlineSolution size={18} />,
          //     hidden: !isAccessible([UserEnum.MANAGER, UserEnum.OPS_MANAGER, UserEnum.OPERATION_SUPERVISOR, UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
          //         UserEnum.OPERATION_CS_SUPERVISOR, UserEnum.MANIFESTER, UserEnum.OPERATION_STAFF, UserEnum.SALES_PERSON])
          // },
          {
            label: 'IRS Manifest',
            key: getRandom(),
            path: '/irs-sales-man-manifest',
            icon: <AiOutlineSolution size={18} />,
            hidden: !(
              isAccessible(
                [UserEnum.MANAGER, UserEnum.OPS_MANAGER, UserEnum.SALES_PERSON, UserEnum.SALES_MANAGER, UserEnum.SALES_DIRECTOR],
                [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
              ) ||
              isAccessible(
                [Employee.LARA, Employee.REEM_ABDULLAH_ALJAMEA, Employee.IMATHUL_RAFI_KSA, Employee.Nouf_AlOmar],
                [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
                true,
              )
            ),
          },
          {
            label: 'Finance Approval',
            key: getRandom(),
            path: '/finance-approval',
            icon: <FcApproval size={17} />,
            hidden: !(
              isAccessible([UserEnum.FINANCE_CONTROLLER], [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN]) ||
              isAccessible([Employee.HALA], [CountryEnum.KSA, CountryEnum.BAHRAIN], true)
            ),
          },
          {
            label: 'IRS Shipment Report',
            key: getRandom(),
            path: '/irs-shipment-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !(
              isAccessible([UserEnum.FINANCE_CONTROLLER], [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN]) ||
              isAccessible([Employee.HALA], [CountryEnum.KSA, CountryEnum.BAHRAIN], true)
            ),
          },
        ].map((item) => ({
          pathname: item?.path,
          name: item?.label,
          key: item?.key,
          label: item?.path ? (
            <NavLink to={item?.path} key={item?.key} replace>
              {item?.label}
            </NavLink>
          ) : (
            item?.label
          ),
          icon: item?.icon,
          hidden: item?.hidden,
        })),
      },
      {
        label: 'Customer Complaint',
        key: getRandom(),
        path: '/customer-complaint',
        icon: <AiOutlineUser size={17} />,
        hidden: !isAccessible([
          UserEnum.OCC_SOLUTION,
          UserEnum.MANAGER,
          UserEnum.OPS_MANAGER,
          UserEnum.OPERATION_SUPERVISOR,
          UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
          UserEnum.OPERATION_CS_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
          UserEnum.MANIFESTER,
          UserEnum.OPERATION_STAFF,
          UserEnum.SALES_PERSON,
          UserEnum.OPERATION_STAFF,
          UserEnum.CUSTOMER_CARE,
          UserEnum.SALES_MANAGER,
          UserEnum.SALES_DIRECTOR,
          UserEnum.CUSTOMER_SERVICE,
          UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
        ]),
      },
      {
        label: 'Piece Barcode Tracking',
        key: getRandom(),
        path: '/piece-barcode-tracking',
        icon: <BiSearch size={17} />,
        hidden: !isAccessible([
          UserEnum.MANAGER,
          UserEnum.OPS_MANAGER,
          UserEnum.OPERATION_SUPERVISOR,
          UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
          UserEnum.FLEET_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
          UserEnum.OPERATION_STAFF,
          UserEnum.MANIFESTER,
          UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
        ]),
      },
      {
        label: 'Alert',
        key: getRandom(),
        path: '/vehicle-alert',
        icon: <MdOutlineBusAlert size={17} />,
        hidden: !isAccessible([
          UserEnum.MANAGER,
          UserEnum.OPS_MANAGER,
          UserEnum.OPERATION_SUPERVISOR,
          UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
          UserEnum.OPERATION_CS_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
          UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
        ]),
      },
      {
        label: "Invoice",
        key: getRandom(),


        hidden: !isAccessible(
          [UserEnum.MANAGER, UserEnum.FINANCE, UserEnum.FINANCE_CONTROLLER],
          [CountryEnum.UAE, CountryEnum.KSA, CountryEnum.BAHRAIN]
        ),
        icon: <FaFileInvoiceDollar size={18} />,
        children: [
          {
            label: 'Staging',
            key: getRandom(),
            path: "/invoice-staging",
            icon: <AiOutlineDollar size={17} />,
            hidden: !isAccessible([
              UserEnum.MANAGER,
              UserEnum.FINANCE,
              UserEnum.FINANCE_CONTROLLER,
            ]),
          },

        ].map((item) => ({
          pathname: item?.path,
          name: item?.label,
          key: item?.key,
          label: item?.path ? (
            <NavLink to={item?.path} key={item?.key} replace>
              {item?.label}
            </NavLink>
          ) : (
            item?.label
          ),
          icon: item?.icon,
          hidden: item?.hidden,
        })),

      },
      {
        label: "Bulk Invoice",
        key: getRandom(),
        path: '/bulk-invoice',
        hidden: !isAccessible(
          [UserEnum.MANIFESTER, UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER, UserEnum.MANAGER],
          [CountryEnum.UAE, CountryEnum.KSA, CountryEnum.BAHRAIN],
        ),
        icon: <TbFileInvoice size={18} />,
      },
      {
        label: 'Vehicle Assignment',
        key: getRandom(),
        path: '/vehicle-assignment',
        icon: <BsTruck size={17} />,
        hidden: !isAccessible([
          UserEnum.MANAGER,
          UserEnum.OPS_MANAGER,
          UserEnum.OPERATION_SUPERVISOR,
          UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
          UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
          UserEnum.FLEET_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
          UserEnum.OPERATION_STAFF,
          UserEnum.OPS_CASH,
        ]),
      },
      {
        label: 'Idle Vehicles',
        key: getRandom(),
        path: '',
        icon: <FaTruckFast size={17} />,
        hidden: isProdMode()
          ? !(
            isAccessible([
              UserEnum.FLEET_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR,
              UserEnum.OPERATION_STAFF,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
              UserEnum.OPS_MANAGER,
              UserEnum.MANAGER,
              UserEnum.OCC_SOLUTION,
            ]) ||
            isMateenProdUser() ||
            isIdleVehicleExceptionTeam()
          )
          : !isAccessible([UserEnum.MANAGER]),
        children: [
          {
            label: 'Idle Vehicles',
            key: getRandom(),
            path: '/idle-vehicles',
            icon: <FaTruckFast size={17} />,
            hidden: isProdMode()
              ? !(
                isAccessible([
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPERATION_CS_SUPERVISOR,
                  UserEnum.OPERATION_STAFF,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                  UserEnum.OPS_MANAGER,
                  UserEnum.MANAGER,
                  UserEnum.OCC_SOLUTION,
                ]) || isMateenProdUser()
              )
              : !isAccessible([UserEnum.MANAGER]),
          },
          {
            label: 'Idle Vehicles Approval',
            key: getRandom(),
            path: '/idle-vehicles-approval',
            icon: <IoMdCheckmarkCircleOutline size={17} />,
            hidden: isProdMode()
              ? !(
                isAccessible([
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.OPS_MANAGER,
                  UserEnum.OCC_SOLUTION,
                ]) ||
                isMateenProdUser() ||
                isIdleVehicleExceptionTeam()
              )
              : !isAccessible([UserEnum.MANAGER]),
          },
        ].map((item) => ({
          pathname: item?.path,
          name: item?.label,
          key: item?.key,
          label: item?.path ? (
            <NavLink to={item?.path} key={item?.key} replace>
              {item?.label}
            </NavLink>
          ) : (
            item?.label
          ),
          icon: item?.icon,
          hidden: item?.hidden,
        })),
      },
      {
        label: 'Fuel Management',
        key: getRandom(),
        path: '',
        icon: <GiOilDrum size={17} />,
        hidden: !(
          isFuelReportTeam() ||
          isAccessible([
            UserEnum.MANAGER,
            UserEnum.OPS_MANAGER,
            UserEnum.FLEET_SUPERVISOR,
            UserEnum.DATA_ANALYST,
            UserEnum.OCC_SOLUTION,
            UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
            UserEnum.OPERATION_SUPERVISOR,
            UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
          ])
        ),
        children: [
          {
            label: 'Fuel Management',
            key: getRandom(),
            path: '/fuel-management',
            icon: <GiOilDrum size={17} />,
            hidden: !isAccessible([
              UserEnum.MANAGER,
              UserEnum.OPS_MANAGER,
              UserEnum.FLEET_SUPERVISOR,
              UserEnum.DATA_ANALYST,
              UserEnum.OCC_SOLUTION,
              UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
            ]),
          },
          {
            label: 'Fuel Report',
            key: getRandom(),
            path: '/meta-fuel-report',
            icon: <AiOutlineSolution size={17} />,
            hidden: !(
              isFuelReportTeam() ||
              isAccessible([
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ])
            ),
          },
          {
            label: 'Fuel Audit',
            key: getRandom(),
            path: '/fuel-audit',
            icon: <RiFolderHistoryFill size={17} />,
            hidden: !(
              isFuelReportTeam() ||
              isAccessible([
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.DATA_ANALYST,
                UserEnum.OCC_SOLUTION,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ])
            ),
          },
        ].map((item) => ({
          pathname: item?.path,
          name: item?.label,
          key: item?.key,
          label: item?.path ? (
            <NavLink to={item?.path} key={item?.key} replace>
              {item?.label}
            </NavLink>
          ) : (
            item?.label
          ),
          icon: item?.icon,
          hidden: item?.hidden,
        })),
      },
      {
        label: 'Odometer Tracking',
        key: getRandom(),
        path: '/odometer',
        icon: <IoSpeedometerOutline size={17} />,
        hidden: !(
          isEditOdometerTeam() ||
          isAccessible([
            UserEnum.MANAGER,
            UserEnum.OPS_MANAGER,
            UserEnum.FLEET_SUPERVISOR,
            UserEnum.OPERATION_SUPERVISOR,
            UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
            UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
            UserEnum.OPERATION_CS_SUPERVISOR,
            UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
          ])
        ),
      },
      {
        label: 'Hub Storage',
        key: getRandom(),
        path: '',
        icon: <SiFlathub size={18} />,
        hidden: !isAccessible([
          UserEnum.MANAGER,
          UserEnum.OPS_MANAGER,
          UserEnum.OPERATION_SUPERVISOR,
          UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
          UserEnum.OPERATION_CS_SUPERVISOR,
          UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
          UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
        ]),
        children: [
          {
            label: 'Hub Storage',
            key: getRandom(),
            path: '/hub-storage',
            icon: <SiFlathub size={18} />,
            hidden: !isAccessible([
              UserEnum.MANAGER,
              UserEnum.OPS_MANAGER,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
              UserEnum.OPERATION_CS_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
              UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
            ]),
          },
          {
            label: 'Daily Hub Scan',
            key: getRandom(),
            path: '/daily-hub-scan',
            icon: <AiOutlineFileSearch size={18} />,
            hidden: !isAccessible([
              UserEnum.MANAGER,
              UserEnum.OPS_MANAGER,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
              UserEnum.OPERATION_CS_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
              UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
            ]),
          },
        ].map((item) => ({
          pathname: item?.path,
          name: item?.label,
          key: item?.key,
          label: item?.path ? (
            <NavLink to={item?.path} key={item?.key} replace>
              {item?.label}
            </NavLink>
          ) : (
            item?.label
          ),
          icon: item?.icon,
          hidden: item?.hidden,
        })),
      },
      // {
      //   label: "Invoice",
      //   key: getRandom(),
      //   path: "/invoice",
      //   icon: <TbFileInvoice size={18} />,
      //   hidden: !isAccessible(
      //     [UserEnum.FINANCE, UserEnum.FINANCE_CONTROLLER],
      //     [CountryEnum.UAE, CountryEnum.KSA, CountryEnum.BAHRAIN]
      //   ),
      // },
      {
        label: 'CN / DN',
        key: getRandom(),
        path: '',
        icon: <CiStickyNote size={18} />,
        hidden: isProdMode()
          ? !(
            isAccessible(
              [
                ...PRICING_TEAM_ACCESS,
                Employee.GOIUSE,
                Employee.ARWA_FINANCE,
                Employee.AMIR_GHAAFFAR,
                Employee.Abdulrahman_ElShafai,
                Employee.Sebastian_Sommer,
                Employee.Abdoulaye_Sarr,
                Employee.KAUSHIK_SAMPAT,
                Employee.Abdulrahman_Jamal,
                Employee.Abdulrahman_ElShafai,
                Employee.NOHA_KARKADAN,
                Employee.MICHAEL_WEIDENBRUCH,
              ],
              [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
              true,
            ) ||
            isAccessible(
              [
                UserEnum.MANAGER,
                UserEnum.SALES_DIRECTOR,
                UserEnum.MANIFESTER,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.FINANCE_CONTROLLER,
              ],
              [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
            )
          )
          : !isAccessible(
            [
              UserEnum.MANAGER,
              UserEnum.SALES_DIRECTOR,
              UserEnum.MANIFESTER,
              UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
              UserEnum.FINANCE_CONTROLLER,
            ],
            [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.KSA],
          ),
        children: [
          {
            label: 'CN / DN',
            key: getRandom(),
            path: 'credit-debit-note',
            icon: <CiStickyNote size={18} />,
            hidden: isProdMode()
              ? !(
                isAccessible(
                  [
                    Employee.Abdulrahman_Jamal, Employee.AMIR_GHAAFFAR, Employee.NOHA_KARKADAN, Employee.Abdulrahman_ElShafai
                  ],
                  [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
                  true,
                )
                ||
                isAccessible(
                  [UserEnum.MANIFESTER, UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER],
                  [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
                )
              )
              : !isAccessible(
                [UserEnum.MANAGER, UserEnum.MANIFESTER, UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER],
                [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
              ),
          },
          {
            label: 'CN/DN Finance Request',
            key: getRandom(),
            path: 'cd-finance-approval',
            icon: <CiStickyNote size={18} />,
            hidden: !(
              isAccessible([UserEnum.FINANCE_CONTROLLER], [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE]) ||
              isAccessible(
                [Employee.AMIR_GHAAFFAR, Employee.Abdulrahman_ElShafai, Employee.KAUSHIK_SAMPAT],
                [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
                true,
              )
            ),
          },
          {
            label: 'CN/DN Director Request',
            key: getRandom(),
            path: 'director-approval',
            icon: <CiStickyNote size={18} />,
            hidden: !(
              isAccessible([UserEnum.MANAGER, UserEnum.SALES_DIRECTOR], [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE]) ||
              isAccessible(
                [Employee.MICHAEL_WEIDENBRUCH],
                [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
                true,
              )
            ),


          },

          {
            label: "CN/DN Division Head Requests",
            key: getRandom(),
            path: "division-head-approval",
            icon: <CiStickyNote size={18} />,
            hidden: !(isAccessible(
              [Employee.Sebastian_Sommer],
              [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
              true,
            )
            ),
          },
          {
            label: "CN/DN CFO Requests",
            key: getRandom(),
            path: "cfo-approval",
            icon: <CiStickyNote size={18} />,
            hidden: !(isAccessible(
              [Employee.Abdoulaye_Sarr],
              [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
              true,
            )
            ),
          },

          {
            label: 'Approved CN / DN List',
            key: getRandom(),
            path: 'cd-notes',
            icon: <CiStickyNote size={18} />,
            hidden: !(
              isAccessible(
                [UserEnum.FINANCE_CONTROLLER, UserEnum.MANAGER],
                [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
              ) ||
              isAccessible(
                [Employee.AMIR_GHAAFFAR, Employee.Abdulrahman_ElShafai, Employee.Abdoulaye_Sarr, Employee.Sebastian_Sommer, Employee.KAUSHIK_SAMPAT, Employee.MICHAEL_WEIDENBRUCH],
                [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
                true,
              )
            ),
          },
        ].map((item) => ({
          pathname: item?.path,
          name: item?.label,
          key: item?.key,
          label: item?.path ? (
            <NavLink to={item?.path} key={item?.key} replace>
              {item?.label}
            </NavLink>
          ) : (
            item?.label
          ),
          icon: item?.icon,
          hidden: item?.hidden,
        })),
      },
      {
        label: 'Enquiry',
        key: getRandom(),
        path: '',
        icon: <TbMessageCircleQuestion size={18} />,
        hidden: !(
          isAccessible(
            [UserEnum.SALES_PERSON, UserEnum.MANAGER, UserEnum.SALES_MANAGER, UserEnum.SALES_DIRECTOR],
            [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
          ) || isAccessible(PRICING_TEAM_USERS, [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE], true)
        ),
        children: [
          {
            label: 'CRM Enquiry',
            key: getRandom(),
            path: '/enquiry/enquiry',
            icon: <TbMessageCircleQuestion size={17} />,
            hidden: !isAccessible([
              UserEnum.MANAGER,
              UserEnum.OPERATION_CS_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
            ]),
          },
          {
            label: 'AIMS Enquiry',
            key: getRandom(),
            path: '/enquiry/enquiries',
            icon: <TbMessageCircleQuestion size={17} />,
            hidden: !(
              isAccessible(
                [UserEnum.SALES_PERSON, UserEnum.MANAGER, UserEnum.SALES_MANAGER, UserEnum.SALES_DIRECTOR],
                [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
              ) || isAccessible(PRICING_TEAM_USERS, [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE], true)
            ),
          },
        ].map((item) => ({
          pathname: item?.path,
          name: item?.label,
          key: item?.key,
          label: item?.path ? (
            <NavLink to={item?.path} key={item?.key} reloadDocument={false} replace>
              {item?.label}
            </NavLink>
          ) : (
            item?.label
          ),
          icon: item?.icon,
          hidden: item?.hidden,
        })),
      },
      {
        label: 'Device',
        key: getRandom(),
        path: '',
        icon: <MdOutlineDeviceThermostat size={18}></MdOutlineDeviceThermostat>,
        hidden: !isAccessible([UserEnum.MANAGER]),
        children: [
          {
            label: 'Realtime',
            key: getRandom(),
            path: '/device/realtime',
            icon: <TiRefreshOutline size={18} />,
            hidden: !isAccessible([UserEnum.MANAGER]),
          },
          {
            label: 'Configuration',
            key: getRandom(),
            path: '/device/configuration',
            icon: <GrDocumentConfig size={18} />,
            hidden: !isAccessible([UserEnum.MANAGER]),
          },
          {
            label: 'History',
            key: getRandom(),
            path: '/device/history',
            icon: <BsClockHistory size={18} />,

            hidden: !isAccessible([UserEnum.MANAGER]),
          },
        ].map((item) => ({
          pathname: item?.path,
          name: item?.label,
          key: item?.key,
          label: item?.path ? (
            <NavLink to={item?.path} key={item?.key} reloadDocument={false} replace>
              {item?.label}
            </NavLink>
          ) : (
            item?.label
          ),
          icon: item?.icon,
          hidden: item?.hidden,
        })),
      },
      {
        label: 'Masters',
        key: getRandom(),
        path: '',
        hidden: !(
          isAccessible([
            UserEnum.MANAGER,
            UserEnum.OPS_MANAGER,
            UserEnum.FLEET_SUPERVISOR,
            UserEnum.OPERATION_SUPERVISOR,
            UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
            UserEnum.OPERATION_CS_SUPERVISOR,
            UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
            UserEnum.DATA_LOGGER,
            UserEnum.OCC_SOLUTION,
            UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
            UserEnum.DATA_ANALYST,
          ]) ||
          isAccessible(
            [Employee.ARWA_FINANCE, Employee.BANDER_ALLAFI, Employee.NOHA_KARKADAN],
            [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
            true,
          ) ||
          isPricingTeam()
        ),
        icon: <AiOutlineDeploymentUnit size={18} />,
        children: [
          buildMenuGroup('OPS Master', <FaTruckMoving size={17} />, [
            {
              label: 'Employee',
              key: getRandom(),
              path: '/employee',
              icon: <AiOutlineUser size={17} />,
              hidden: !isAccessible([
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.MANIFESTER,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ]),
            },
            {
              label: 'Vehicle',
              key: getRandom(),
              path: '/vehicles',
              icon: <BsTruck size={17} />,
              hidden: !(
                isEditVehicleTeam() ||
                isAccessible([
                  UserEnum.MANAGER,
                  UserEnum.OPS_MANAGER,
                  UserEnum.FLEET_SUPERVISOR,
                  UserEnum.DATA_LOGGER,
                  UserEnum.OPERATION_SUPERVISOR,
                  UserEnum.OCC_SOLUTION,
                  UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum.DATA_ANALYST,
                ]) ||
                isAccessible(
                  [Employee.ARWA_FINANCE, Employee.BANDER_ALLAFI, Employee.NOHA_KARKADAN],
                  [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
                  true,
                )
              ),
            },
            {
              label: 'Trip Route',
              key: getRandom(),
              path: '/trip-routes',
              icon: <BiTrip size={17} />,
              hidden: !isAccessible([UserEnum.MANAGER, UserEnum.OPS_MANAGER, UserEnum.FLEET_SUPERVISOR]),
            },
            // { label: 'Transit Matrix', key: '12', path: '/transit-matrix', icon: '' },
            // { label: 'Transit Exceptions', key: '13', path: '/transit-exceptions', icon: '' },
            // { label: 'Transit Drivers', key: '14', path: '/transit-drivers', icon: '' },
            {
              label: 'City',
              key: 13,
              path: '/city',
              icon: <FaCity size={17} />,
              hidden: !isAccessible(
                [Employee.MATEEN_DEV, Employee.MATEEN_PROD],
                [CountryEnum.KSA, CountryEnum.BAHRAIN, CountryEnum.UAE],
                true,
              ),
            },
            {
              label: 'Country',
              key: getRandom(),
              path: '/country',
              icon: <AiOutlineCompass size={17} />,
              hidden: !isAccessible([UserEnum.MANAGER, UserEnum.OPS_MANAGER]),
            },
            {
              label: 'Region',
              key: getRandom(),
              path: '/region',
              icon: <AiOutlineGlobal size={17} />,
              hidden: !isAccessible([UserEnum.MANAGER, UserEnum.OPS_MANAGER]),
            },
            // { label: 'Configurations', key: '18', path: '/configurations', icon: <GrDocumentConfig size={18} /> },
            // { label: 'Routes', key: '19', path: '/routes', icon: <FaRoute size={18} /> },
            // { label: 'User Roles', key: '21', path: '/user-roles', icon: <AiOutlineUser size={18} /> },
            {
              label: 'Event',
              key: getRandom(),
              path: '/event',
              icon: <AiOutlineFile size={17} />,
              hidden: !isAccessible([UserEnum.MANAGER, UserEnum.OPS_MANAGER]),
            },
            {
              label: 'Exception',
              key: getRandom(),
              path: '/exception',
              icon: <AiOutlineException size={17} />,
              hidden: !isAccessible([UserEnum.MANAGER, UserEnum.OPS_MANAGER]),
            },
            {
              label: 'Driver',
              key: getRandom(),
              path: '/driver',
              icon: <AiOutlineUser size={17} />,
              hidden: !isAccessible([UserEnum.MANAGER, UserEnum.OPS_MANAGER, UserEnum.FLEET_SUPERVISOR]),
            },
            {
              label: 'ODA',
              key: getRandom(),
              path: '/oda',
              icon: <FaCity size={17} />,
              hidden: !isAccessible([UserEnum.MANAGER, UserEnum.OPS_MANAGER]),
            },
            {
              label: 'Station',
              key: getRandom(),
              path: '/station',
              icon: <FaCity size={17} />,
              hidden: !isAccessible([
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ]),
            },
            {
              label: 'Vehicle Details',
              key: getRandom(),
              path: '/vehicles-details',
              icon: <AiOutlineCar size={17} />,
              hidden: !isAccessible([
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ]),
            },
            {
              label: 'Shippers',
              key: getRandom(),
              path: '/shippers',
              icon: <FaShippingFast size={17} />,
              hidden: !isAccessible([
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
              ]),
            },
            {
              label: 'Consignee',
              key: getRandom(),
              path: '/consignee',
              icon: <FaShippingFast size={17} />,
              hidden: !isAccessible([
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ]),
            },
            {
              label: 'Box Management',
              key: getRandom(),
              path: '/box-management',
              icon: <BsBox size={17} />,
              hidden: !isAccessible([
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ]),
            },
            {
              label: 'Tray Management',
              key: getRandom(),
              path: '/tray-management',
              icon: <AiOutlineInbox size={17} />,
              hidden: !isAccessible([
                UserEnum.MANAGER,
                UserEnum.OPS_MANAGER,
                UserEnum.OPERATION_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR,
                UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
                UserEnum.FLEET_SUPERVISOR,
                UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
              ]),
            },
          ]),
          buildMenuGroup('Pricing Master', <AiOutlineDollar size={17} />, [
            {
              label: 'Products',
              key: getRandom(),
              path: '/products',
              icon: <MdProductionQuantityLimits size={17} />,
              hidden: !isAccessible([UserEnum.MANAGER, UserEnum.OPS_MANAGER]),
            },
            {
              label: 'ODA',
              key: getRandom(),
              path: '/oda',
              icon: <FaCity size={17} />,
              hidden: !isAccessible([UserEnum.MANAGER, UserEnum.OPS_MANAGER]),
            },
            {
              label: 'Default Manual Waybill Prices',
              key: getRandom(),
              path: '/manual-waybill-charges',
              icon: <HiOutlineCash size={17} />,
              hidden: !isAccessible([Employee.FARAH, Employee.ALANOUD, Employee.MATEEN_PROD], [CountryEnum.KSA, CountryEnum.UAE, CountryEnum.BAHRAIN], true),
            },
          ]),
        ],
      },
      {
        label: 'User Auth Creation',
        key: getRandom(),
        path: '/user-auth-creation',
        icon: <AiOutlineUserAdd size={18} />,
        hidden: !isAccessible([UserEnum.IT_SUPPORT]),
      },
      {
        label: 'Change Request',
        key: getRandom(),
        path: '',
        icon: <MdFreeCancellation size={18} />,
        hidden: !isAccessible([
          UserEnum?.OPS_MANAGER,
          UserEnum?.OPERATION_SUPERVISOR,
          UserEnum?.MANAGER,
          UserEnum?.OPERATION_SUPERVISOR_OPERATION_STAFF,
          UserEnum?.OPERATION_SUPERVISOR_CASH_COLLECTOR,
        ]),
        children: [
          {
            label: 'Pickup Cancellation Requests',
            key: getRandom(),
            path: '/pickup-cancellation',
            icon: <MdOutlineFreeCancellation size={18} />,
            hidden: !(
              isAccessible(
                [
                  UserEnum?.OPS_MANAGER,
                  UserEnum?.OPERATION_SUPERVISOR,
                  UserEnum?.MANAGER,
                  UserEnum?.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum?.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                ],
                [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
              )
              // ||
              // isAccessible(
              //   [Employee.LARA, Employee.REEM_ABDULLAH_ALJAMEA],
              //   [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
              //   true
              // )
            ),
          },
          {
            label: 'Barcode Requests',
            key: getRandom(),
            path: '/barcode-change-request',
            icon: <IoMdBarcode size={18} />,
            hidden: !(
              isAccessible(
                [
                  UserEnum?.OPS_MANAGER,
                  UserEnum?.OPERATION_SUPERVISOR,
                  UserEnum?.MANAGER,
                  UserEnum?.OPERATION_SUPERVISOR_OPERATION_STAFF,
                  UserEnum?.OPERATION_SUPERVISOR_CASH_COLLECTOR,
                ],
                [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
              )
              //  ||
              // isAccessible(
              //   [Employee.LARA, Employee.REEM_ABDULLAH_ALJAMEA],
              //   [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
              //   true
              // )
            ),
          },
        ].map((item) => ({
          pathname: item?.path,
          name: item?.label,
          key: item?.key,
          label: item?.path ? (
            <NavLink to={item?.path} key={item?.key} replace>
              {item?.label}
            </NavLink>
          ) : (
            item?.label
          ),
          icon: item?.icon,
          hidden: item?.hidden,
        })),
      },
      // {
      //   label: "Delivery Reschedule",
      //   key: getRandom(),
      //   path: "/delivery-reschedule",
      //   icon: <TbTruckDelivery size={18} />,
      //   hidden: !isAccessible([UserEnum.MANAGER, UserEnum.SALES_MANAGER, UserEnum.SALES_PERSON]),

      // },
      {
        label: 'Adhoc',
        key: getRandom(),
        icon: <LiaAdversal size={18} />,
        hidden: !(
          isAccessible(
            [
              UserEnum.MANAGER,
              UserEnum.OPS_MANAGER,
              UserEnum.OPERATION_SUPERVISOR,
              UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
              UserEnum.OPERATION_CS_SUPERVISOR,
              UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
              UserEnum.OPERATION_STAFF,
              UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
            ],
            [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA],
          ) ||
          isAccessible([Employee.MOHAMMAD_SHABAZ], [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA], true)
        ),
        children: [
          {
            label: 'Adhoc Trip',
            key: getRandom(),
            path: '/adhoc-trip',
            icon: <LiaAdversal size={18} />,
            hidden: !isNewAccessible({
              employeeIds: AdhocTripTabRoles?.employeeIds,
            }),
          },
          {
            label: 'ADHOC Report',
            key: getRandom(),
            path: '/adhoc-report',
            icon: <IoMdBarcode size={18} />,
          },
          {
            label: 'Vendor Master',
            key: getRandom(),
            path: '/adhoc-vendor-master',
            icon: <IoMdBarcode size={18} />,
            hidden: !isNewAccessible({
              employeeIds: AdhocVendor_TripApproval_Roles?.employeeIds,
            }),
          },
        ].map((item) => ({
          pathname: item?.path,
          name: item?.label,
          key: item?.key,
          label: item?.path ? (
            <NavLink to={item?.path} key={item?.key} replace>
              {item?.label}
            </NavLink>
          ) : (
            item?.label
          ),
          icon: item?.icon,
          hidden: item?.hidden,
        })),
      },
      {
        label: 'AIMS Handbook',
        key: getRandom(),
        path: '',
        icon: <AiOutlineFile size={18} />,
        disabled: false,
        children: [
          {
            label: 'Sales & Operations',
            key: getRandom(),
            path: '/sales-opeation-handbook',
            icon: <AiOutlineFilePdf size={18} />,
          },
          {
            label: 'Ground Operation',
            key: getRandom(),
            path: '/ground-opeation-handbook',
            icon: <AiOutlineFilePdf size={18} />,
          },
        ].map((item) => ({
          pathname: item?.path,
          name: item?.label,
          key: item?.key,
          label: item?.path ? (
            <NavLink to={item?.path} key={item?.key} replace>
              {item?.label}
            </NavLink>
          ) : (
            item?.label
          ),
          icon: item?.icon,
        })),
      },
      {
        label: 'Terms & Condition',
        key: getRandom(),
        path: '/agreement',
        icon: <AiOutlineBook size={18} />,
      },
    ].map((item) => {
      return {
        pathname: item?.path,
        name: item?.label,
        key: item?.key,
        label: item?.path ? (
          <NavLink to={item?.path} replace>
            {item?.label}
          </NavLink>
        ) : (
          item?.label
        ),
        icon: item?.icon,
        children: item?.children,
        hidden: item?.hidden,
        disabled: item?.disabled,
      };
    });
  }, [employeeDetail?.employeeId]);

  const itemsWithTooltips = useMemo(() => addTooltips(items), [items]);

  const getCurrentIndex = useCallback(
    () => (items.findIndex((item) => item?.pathname === location?.pathname) + 1).toString(),
    [items, location],
  );

  const onCollapseHandler = (value: any) => {
    SessionStorage.set('isCollapsed', value);
    setCollapsed(value);
  };
  return (
    <Layout className='site-layout' style={{ height: '100vh' }}>
      {/* Sidebar */}
      <Sider
        width={220}
        collapsedWidth={48}
        collapsible
        collapsed={collapsed}
        onCollapse={onCollapseHandler}
        theme='light'
        defaultCollapsed={true}
        style={{
          height: '100vh',
          overflow: 'hidden',
          boxShadow: '2px 0 8px rgba(0,0,0,0.08)',
          zIndex: 100,
        }}
      >
        <ImageDiv collapsed={collapsed}>
          <Image
            preview={false}
            alt='ajex_logo'
            width={collapsed ? 28 : 130}
            src={imageUrl}
            style={{ transition: 'width 0.2s', objectFit: 'contain' }}
          />
        </ImageDiv>

        <div
          style={{
            overflowY: 'auto',
            overflowX: 'hidden',
            height: 'calc(100vh - 60px - 40px)',
            scrollbarWidth: 'thin',
            scrollbarColor: '#d9d9d9 transparent',
          }}
        >
          <Menu
            defaultSelectedKeys={[getCurrentIndex()]}
            mode='inline'
            theme='light'
            inlineIndent={12}
            items={itemsWithTooltips}
            onClick={(e: any) => {
              if (MENU_APP_MAP[e?.item?.props?.name]) {
                SessionStorage.set('token', SessionStorage.get('token')!);
                window.open(`${window.location.origin}${MENU_APP_MAP[e?.item?.props?.name]}`, '_blank');
              }
            }}
            id='ant-menu-sidebar'
          />
        </div>
      </Sider>

      {/* Main layout */}
      <Layout style={{ height: '100vh', overflow: 'hidden', background: '#f5f6fa' }}>
        {/* Sticky Header */}
        <HeaderComponent menuItems={items} />

        {/* Scrollable Content */}
        <Content
          style={{
            padding: "0.3rem",
            overflowY: 'auto',
            height: 'calc(100vh - 60px)',
            background: '#f5f6fa',
          }}
        >
          <div style={{ padding: '8px' }}>
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
